
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire244a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire244a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8FBvR", function(module, exports) {

$parcel$export(module.exports, "verifyDisabled", () => $64ff4053573ab001$export$94ca4fa056e6df83);
$parcel$export(module.exports, "pageSelector", () => $64ff4053573ab001$export$912099cf673aaa36);
$parcel$export(module.exports, "organizationSelector", () => $64ff4053573ab001$export$3b0cadee2e474bed);
$parcel$export(module.exports, "patientIdSelector", () => $64ff4053573ab001$export$5e71298ee9890971);
$parcel$export(module.exports, "patientSerSelector", () => $64ff4053573ab001$export$1e847a9a7d842134);
$parcel$export(module.exports, "configSelector", () => $64ff4053573ab001$export$c4eab2544a80bbf);
$parcel$export(module.exports, "meSelector", () => $64ff4053573ab001$export$2ee062cf7d916851);
$parcel$export(module.exports, "settingsSelector", () => $64ff4053573ab001$export$3edecab98d698790);
$parcel$export(module.exports, "imageQueuePatientStatusSelector", () => $64ff4053573ab001$export$bc85ecf59599cd44);
$parcel$export(module.exports, "settingsLoadedSelector", () => $64ff4053573ab001$export$359575c2088e79bd);
$parcel$export(module.exports, "documentIdSelector", () => $64ff4053573ab001$export$82fe8d2349bc42f1);
$parcel$export(module.exports, "documentTypeSelector", () => $64ff4053573ab001$export$81e672a345b7fda7);
$parcel$export(module.exports, "settingsPageSelector", () => $64ff4053573ab001$export$f6e628a374dc7941);
$parcel$export(module.exports, "showOverlaySelector", () => $64ff4053573ab001$export$670ef761bea9ff63);
$parcel$export(module.exports, "systemSettingsSelector", () => $64ff4053573ab001$export$685619cf7222ff1b);
$parcel$export(module.exports, "paramSelector", () => $64ff4053573ab001$export$4e02e87e243576);
$parcel$export(module.exports, "organizationIdSelector", () => $64ff4053573ab001$export$e92b0df43b477df5);
$parcel$export(module.exports, "organizationSlugSelector", () => $64ff4053573ab001$export$2317734504816e0b);

var $eGMym = parcelRequire("eGMym");

var $kYBQo = parcelRequire("kYBQo");
const $64ff4053573ab001$var$createSelector = (path, defaultValue)=>(0, $eGMym.createSelector)(path, defaultValue);
const $64ff4053573ab001$export$94ca4fa056e6df83 = $64ff4053573ab001$var$createSelector('app.verifyDisabled');
const $64ff4053573ab001$export$912099cf673aaa36 = $64ff4053573ab001$var$createSelector('app.page');
const $64ff4053573ab001$export$3b0cadee2e474bed = $64ff4053573ab001$var$createSelector('app.params.organization');
const $64ff4053573ab001$export$5e71298ee9890971 = $64ff4053573ab001$var$createSelector([
    'app.patient.id',
    'app.params.patient'
]);
const $64ff4053573ab001$export$1e847a9a7d842134 = $64ff4053573ab001$var$createSelector([
    'app.params.patientSer',
    'app.patient.ser',
    'app.params.ser'
]);
const $64ff4053573ab001$export$c4eab2544a80bbf = $64ff4053573ab001$var$createSelector('app.config', {});
const $64ff4053573ab001$export$2ee062cf7d916851 = $64ff4053573ab001$var$createSelector('app.me');
const $64ff4053573ab001$export$3edecab98d698790 = $64ff4053573ab001$var$createSelector('app.settings');
const $64ff4053573ab001$export$bc85ecf59599cd44 = $64ff4053573ab001$var$createSelector('app.imageQueuePatientStatus');
const $64ff4053573ab001$export$359575c2088e79bd = $64ff4053573ab001$var$createSelector('app.settingsLoaded');
const $64ff4053573ab001$export$82fe8d2349bc42f1 = $64ff4053573ab001$var$createSelector('app.params.documentId');
const $64ff4053573ab001$export$81e672a345b7fda7 = $64ff4053573ab001$var$createSelector('app.params.documentType');
const $64ff4053573ab001$export$f6e628a374dc7941 = $64ff4053573ab001$var$createSelector('app.params.page', 'main');
const $64ff4053573ab001$export$670ef761bea9ff63 = $64ff4053573ab001$var$createSelector('app.showOverlay');
const $64ff4053573ab001$export$685619cf7222ff1b = $64ff4053573ab001$var$createSelector('app.systemSettings');
const $64ff4053573ab001$export$4e02e87e243576 = (param, defaultValue)=>$64ff4053573ab001$var$createSelector(`app.params.${param}`, defaultValue);
const $64ff4053573ab001$export$e92b0df43b477df5 = (state = (0, $kYBQo.getStore)().getState())=>{
    const me = $64ff4053573ab001$export$2ee062cf7d916851(state);
    const { id: id } = (me || {
        organizations: []
    }).organizations.find(({ slug: slug })=>$64ff4053573ab001$export$3b0cadee2e474bed(state) === slug) || {};
    if (id) return id;
    if (me) return me.organizations[0].id;
};
const $64ff4053573ab001$export$2317734504816e0b = (state = (0, $kYBQo.getStore)().getState())=>{
    const me = $64ff4053573ab001$export$2ee062cf7d916851(state);
    const { slug: slug } = (me || {
        organizations: []
    }).organizations.find(({ slug: slug })=>$64ff4053573ab001$export$3b0cadee2e474bed(state) === slug) || {};
    if (slug) return slug;
    if (me) return me.organizations[0].slug;
};

});
parcelRegister("eGMym", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $ab1aa69c9d6027db$export$595d22ed68ca2841);

var $gD1Wi = parcelRequire("gD1Wi");

var $kYBQo = parcelRequire("kYBQo");
const $ab1aa69c9d6027db$export$595d22ed68ca2841 = (pathOrPaths, defaultValue)=>(state = (0, $kYBQo.getStore)().getState())=>(Array.isArray(pathOrPaths) ? pathOrPaths : [
            pathOrPaths
        ]).map((path)=>(0, $gD1Wi.safeSelect)(state || (0, $kYBQo.getStore)().getState(), path)).find(Boolean) || defaultValue;

});
parcelRegister("gD1Wi", function(module, exports) {

$parcel$export(module.exports, "safeSelect", () => $c1b1caf025d8f006$export$2a2a8eb8e6221960);
const $c1b1caf025d8f006$export$2a2a8eb8e6221960 = (obj, path)=>{
    const parts = path.split(/\./g);
    let current = obj;
    while(current && parts.length)current = current[parts.shift()];
    return current;
};

});

parcelRegister("kYBQo", function(module, exports) {

$parcel$export(module.exports, "getStore", () => $f456c44efbe64bc9$export$6fec604aa7293d0c);

var $6OKUw = parcelRequire("6OKUw");
const $f456c44efbe64bc9$export$6fec604aa7293d0c = ()=>(0, $6OKUw.storeManager).store;

});
parcelRegister("6OKUw", function(module, exports) {

$parcel$export(module.exports, "storeManager", () => $4f6bcd1498deb2f2$export$39296ef2d3db5938);
// This should only be used by getStore() and setStore.
// Don't export in store/fancy-multi-dropdown.js
const $4f6bcd1498deb2f2$export$39296ef2d3db5938 = {
    store: undefined
};

});




parcelRegister("ivRuz", function(module, exports) {

$parcel$export(module.exports, "removeValueMatching", () => $d7a49da8d55ceef4$export$d395a35fa2314d08);

var $kQ0MG = parcelRequire("kQ0MG");
const $d7a49da8d55ceef4$export$d395a35fa2314d08 = (arr, test)=>{
    const value = arr.find(test);
    return (0, $kQ0MG.removeValue)(arr, value);
};

});
parcelRegister("kQ0MG", function(module, exports) {

$parcel$export(module.exports, "removeValue", () => $f2b945afa476a979$export$9de35760a8cd4b1c);

var $5tEcj = parcelRequire("5tEcj");
const $f2b945afa476a979$export$9de35760a8cd4b1c = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index === -1) return [
        ...arr
    ];
    return (0, $5tEcj.splice)(arr, index, 1);
};

});
parcelRegister("5tEcj", function(module, exports) {

$parcel$export(module.exports, "splice", () => $3fced79926749a50$export$869882364835d202);
const $3fced79926749a50$export$869882364835d202 = (arr, index, numberToRemove = 0, ...newValues)=>{
    if (index < 0 || index >= arr.length) throw new Error('Index for splicing must be greater than zero and less than the max index of the array.');
    return [
        ...arr.slice(0, index),
        ...newValues,
        ...arr.slice(index + numberToRemove)
    ];
};

});



parcelRegister("dgn0U", function(module, exports) {

$parcel$export(module.exports, "replaceValue", () => $9a7e9f0762db4167$export$72b96499c2d8d4d2);

var $5tEcj = parcelRequire("5tEcj");
const $9a7e9f0762db4167$export$72b96499c2d8d4d2 = (arr, valueToReplace, newValue)=>{
    const index = arr.indexOf(valueToReplace);
    if (index === -1) return [
        ...arr,
        newValue
    ];
    return (0, $5tEcj.splice)(arr, index, 1, newValue);
};

});

parcelRegister("jIFAb", function(module, exports) {

$parcel$export(module.exports, "replaceValueMatching", () => $e5b261d545779792$export$fd1f0be3157ea3d2);

var $dgn0U = parcelRequire("dgn0U");
const $e5b261d545779792$export$fd1f0be3157ea3d2 = (arr, test, newValue)=>{
    const value = arr.find(test);
    return (0, $dgn0U.replaceValue)(arr, value, newValue);
};

});

parcelRegister("04gBu", function(module, exports) {

$parcel$export(module.exports, "Routes", () => $00cd40fb284c8120$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "routes", () => $00cd40fb284c8120$export$66b32f6f30eb4b4);
/* global process */ parcelRequire("800sp");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("fOc7S");

var $lmwUx = parcelRequire("lmwUx");

var $ekDVr = parcelRequire("ekDVr");
const $00cd40fb284c8120$export$3565eb3d00ca5a74 = {
    Root: 'root',
    WeeklyCheckLanding: 'weekly-check-landing',
    WeeklyCheckOrganization: 'weekly-check-organization',
    WeeklyCheckPatient: 'weekly-check-patient',
    NotFound404: '404-not-found',
    OrganizationSettingsMain: 'organization-settings-main-view',
    OrganizationSettingsSub: 'organization-settings-sub',
    Document: 'document',
    Image: 'image',
    DoseAccumulated: 'dose-accmulated',
    DoseDelivered: 'dose-delivered',
    Landing: 'landing',
    Login: 'login',
    Logout: 'logout',
    AdminUsers: 'auth-users',
    AdminOrganizations: 'auth-organizations',
    AdminPermissions: 'auth-permissions',
    AdminRoot: 'landing-root',
    AdminLanding: 'landing-admin',
    ResetPassword: 'reset-password',
    ForgotPassword: 'forgot-password',
    BlankImage: 'images-not-loaded',
    Batch: 'batch',
    Image2: 'image2',
    SupportImageViewer: 'support-skia-viewer',
    SupportImageViewerIndex: 'support-skia-viewer-index',
    SupportImportPatient: 'support-import-patient',
    SupportTimeTool: 'support-time-tool',
    ResearchLanding: 'research-landing',
    ResearchPatient: 'research-patient',
    EditDvf: 'edit-dvf'
};


























const $00cd40fb284c8120$export$66b32f6f30eb4b4 = {
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Root]: {
        route: '/',
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckLanding
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckLanding]: {
        route: '/weekly-check',
        permissions: [
            (0, $ekDVr.ACCESS_WEEKLY_PERMISSION)
        ],
        view: ()=>(parcelRequire("h1bTJ")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    'organization-without-patient': {
        route: '/weekly-check/:organization',
        permissions: [
            (0, $ekDVr.ACCESS_WEEKLY_PERMISSION)
        ],
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckOrganization
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckPatient]: {
        route: '/weekly-check/:organization/patient/:patientSer',
        permissions: [
            (0, $ekDVr.ACCESS_WEEKLY_PERMISSION)
        ],
        view: ()=>(parcelRequire("h1bTJ")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckOrganization]: {
        route: '/weekly-check/:organization/patient',
        permissions: [
            (0, $ekDVr.ACCESS_WEEKLY_PERMISSION)
        ],
        view: ()=>(parcelRequire("h1bTJ")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.OrganizationSettingsMain]: {
        route: '/weekly-check/:organization/settings',
        view: ()=>(parcelRequire("45Pkd")),
        title: 'WeeklyCheck Settings',
        render: ()=>(0, $jJTNo.html)`<settings-view></settings-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.OrganizationSettingsSub]: {
        route: '/weekly-check/:organization/settings/:page',
        view: ()=>(parcelRequire("45Pkd")),
        title: 'WeeklyCheck Settings',
        render: ()=>(0, $jJTNo.html)`<settings-view></settings-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Document]: {
        route: '/weekly-check/:organization/document/:documentType/:documentId',
        view: ()=>(parcelRequire("cMErj")),
        title: 'WeeklyCheck - Document',
        render: ()=>(0, $jJTNo.html)`<document-view></document-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Image]: {
        route: '/weekly-check/:organization/image/:patientSer/:planSer/:fraction/:index',
        view: ()=>(parcelRequire("h6uha")),
        title: 'WeeklyCheck - Skia',
        render: ()=>(0, $jJTNo.html)`<skia-view mode=${0, $lmwUx.MODE_IMAGE}></skia-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.DoseAccumulated]: {
        route: '/weekly-check/:organization/dose/accumulated/:patientSer/:planSer/:planSumSer/:index',
        view: ()=>(parcelRequire("h6uha")),
        title: 'WeeklyCheck - Skia',
        render: ()=>(0, $jJTNo.html)`<skia-view mode=${0, $lmwUx.MODE_DOSE} type=${0, $lmwUx.TYPE_ACCUMULATED}></skia-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.DoseDelivered]: {
        route: '/weekly-check/:organization/dose/delivered/:patientSer/:planSer/:fraction/:index',
        view: ()=>(parcelRequire("h6uha")),
        title: 'WeeklyCheck - Skia',
        render: ()=>(0, $jJTNo.html)`<skia-view mode=${0, $lmwUx.MODE_DOSE} type=${0, $lmwUx.TYPE_DELIVERED}></skia-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.EditDvf]: {
        route: '/weekly-check/:organization/dose/delivered/:patientSer/:planSer/:fraction/:index/edit',
        view: ()=>(parcelRequire("h6uha")),
        title: 'WeeklyCheck - Skia',
        render: ()=>(0, $jJTNo.html)`<skia-view mode=${0, $lmwUx.MODE_DVF}></skia-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.NotFound404]: {
        notFound: true,
        view: ()=>(parcelRequire("bEmB9")),
        title: '404 Not Found',
        render: ()=>(0, $jJTNo.html)`<error-404-view></error-404-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Login]: {
        route: '/auth/login',
        view: ()=>(parcelRequire("bJq1a")),
        title: 'Login',
        render: ()=>(0, $jJTNo.html)`<login-view></login-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Logout]: {
        route: '/auth/logout',
        forward: '/login'
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminRoot]: {
        route: '/auth',
        view: ()=>(parcelRequire("b7hXe")),
        title: 'Admin - Users',
        render: ()=>(0, $jJTNo.html)`<users-view></users-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminLanding]: {
        route: '/auth/:organization',
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.AdminUsers
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminUsers]: {
        route: '/auth/:organization/users',
        view: ()=>(parcelRequire("b7hXe")),
        title: 'Admin - Users',
        render: ()=>(0, $jJTNo.html)`<users-view></users-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminOrganizations]: {
        route: '/auth/:organization/organizations',
        view: ()=>(parcelRequire("10W5X")),
        title: 'Admin - Organizations',
        render: ()=>(0, $jJTNo.html)`<organizations-view></organizations-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminPermissions]: {
        route: '/auth/:organization/permissions',
        view: ()=>(parcelRequire("5K5zE")),
        title: 'Admin - Permissions',
        render: ()=>(0, $jJTNo.html)`<permissions-view></permissions-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ResetPassword]: {
        route: '/auth/password/reset',
        view: ()=>(parcelRequire("gPUTI")),
        title: 'Password Reset',
        render: ()=>(0, $jJTNo.html)`<password-reset-view></password-reset-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ForgotPassword]: {
        route: '/auth/password/forgot',
        view: ()=>(parcelRequire("h3KHP")),
        title: 'Forgot Password',
        render: ()=>(0, $jJTNo.html)`<password-forgot-view></password-forgot-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.BlankImage]: {
        route: '/weekly-check/:organization/image/:ser/blank',
        view: ()=>(parcelRequire("hImB1")),
        title: 'Images Not Loaded',
        render: ()=>(0, $jJTNo.html)`<blank-image-view></blank-image-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Batch]: {
        route: '/weekly-check/:organization/batch',
        permissions: [
            (0, $ekDVr.BATCH_PERMISSION)
        ],
        view: ()=>(parcelRequire("igtwO")),
        title: 'Batch Approval',
        render: ()=>(0, $jJTNo.html)`<batch-view></batch-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportImageViewer]: {
        route: '/support/image',
        view: ()=>(parcelRequire("6V5Ja")),
        title: 'Skia Image Viewer',
        render: ()=>(0, $jJTNo.html)`<support-skia-viewer></support-skia-viewer>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportImageViewerIndex]: {
        route: '/support/image/:index',
        view: ()=>(parcelRequire("6V5Ja")),
        title: 'Skia Image Viewer',
        render: ()=>(0, $jJTNo.html)`<support-skia-viewer></support-skia-viewer>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportTimeTool]: {
        route: '/support/time',
        view: ()=>(parcelRequire("gWdO2")),
        title: 'Time Testing Tool',
        render: ()=>(0, $jJTNo.html)`<time-tool></time-tool>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ResearchLanding]: {
        route: '/weekly-check/:organization/research',
        permissions: [
            (0, $ekDVr.RESEARCH_PERMISSION)
        ],
        view: ()=>(parcelRequire("h1bTJ")),
        title: 'Research Review',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view .researchMode=${true}></weekly-plan-check-view>`
    },
    'research-without-patientSer': {
        route: '/weekly-check/:organization/research/patient',
        permissions: [
            (0, $ekDVr.RESEARCH_PERMISSION)
        ],
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.ResearchLanding
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ResearchPatient]: {
        route: '/weekly-check/:organization/research/patient/:patientSer',
        permissions: [
            (0, $ekDVr.RESEARCH_PERMISSION)
        ],
        view: ()=>(parcelRequire("h1bTJ")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view .researchMode=${true}></weekly-plan-check-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportImportPatient]: {
        route: '/support/import',
        view: ()=>(parcelRequire("cgO50")),
        title: 'Import Patient',
        render: ()=>(0, $jJTNo.html)`<import-patient-view></import-patient-view>`
    }
};

});
parcelRegister("800sp", function(module, exports) {
parcelRequire("3qR54");
parcelRequire("jJTNo");

var $lPSdM = parcelRequire("lPSdM");

var $8FVzH = parcelRequire("8FVzH");
$parcel$exportWildcard(module.exports, $lPSdM);
$parcel$exportWildcard(module.exports, $8FVzH);

});
parcelRegister("3qR54", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $27fcf98b67c2a783$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $27fcf98b67c2a783$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $27fcf98b67c2a783$export$c7c07a37856565d);
$parcel$export(module.exports, "CSSResult", () => (parcelRequire("4jdI8")).CSSResult);
$parcel$export(module.exports, "adoptStyles", () => (parcelRequire("4jdI8")).adoptStyles);
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "getCompatibleStyle", () => (parcelRequire("4jdI8")).getCompatibleStyle);
$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => (parcelRequire("4jdI8")).supportsAdoptingStyleSheets);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4jdI8")).unsafeCSS);

var $4jdI8 = parcelRequire("4jdI8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$r, getOwnPropertyNames: $27fcf98b67c2a783$var$h, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$y = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $27fcf98b67c2a783$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $27fcf98b67c2a783$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$h(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $4jdI8.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $4jdI8.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $4jdI8.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("4jdI8", function(module, exports) {

$parcel$export(module.exports, "supportsAdoptingStyleSheets", () => $3233927aa82734f9$export$b4d10f6001c083c2);
$parcel$export(module.exports, "CSSResult", () => $3233927aa82734f9$export$505d1e8739bad805);
$parcel$export(module.exports, "unsafeCSS", () => $3233927aa82734f9$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $3233927aa82734f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $3233927aa82734f9$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $3233927aa82734f9$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $e5ed8027d647799b$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "mathml", () => $e5ed8027d647799b$export$47d5b44d225be5b4);
$parcel$export(module.exports, "noChange", () => $e5ed8027d647799b$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $e5ed8027d647799b$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $e5ed8027d647799b$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.2.1");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("lPSdM", function(module, exports) {

$parcel$export(module.exports, "LitElement", () => $fe586ba0757c37f7$export$3f2f9f5909897157);
$parcel$export(module.exports, "_$LE", () => $fe586ba0757c37f7$export$f5c524615a7708d6);

var $3qR54 = parcelRequire("3qR54");

var $jJTNo = parcelRequire("jJTNo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $3qR54.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const s = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $jJTNo.render)(s, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $jJTNo.noChange;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$i = globalThis.litElementPolyfillSupport;
$fe586ba0757c37f7$var$i?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.1");
$parcel$exportWildcard(module.exports, $3qR54);
$parcel$exportWildcard(module.exports, $jJTNo);

});

parcelRegister("8FVzH", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $650ed036964a13b8$export$6acf61af03e62db);
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;

});


parcelRegister("fOc7S", function(module, exports) {

$parcel$export(module.exports, "DevRoutes", () => $b824ee8513f026d6$export$8a1e4e5afb28371c);
// Prepend all the strings with dev- to avoid collision with the real routes.
parcelRequire("800sp");
var $jJTNo = parcelRequire("jJTNo");
const $b824ee8513f026d6$export$8a1e4e5afb28371c = {
    Home: 'dev-home',
    FancyTableDemo: 'fancy-table-demo',
    SkiaSpeedTest: 'skia-speed-test',
    WizardDemo: 'wizard-demo',
    HealthCheckDemo: 'health-check-demo',
    MigrateDemo: 'migrate-demo',
    PushTool: 'push-tool'
};







const $b824ee8513f026d6$export$2c4cc286c1ce8a84 = {
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.Home]: {
        route: '/dev',
        view: ()=>(parcelRequire("kl35R")),
        title: 'Dev Home',
        render: ()=>(0, $jJTNo.html)`<dev-home></dev-home>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.SkiaSpeedTest]: {
        route: '/dev/skia-speed-test',
        view: ()=>(parcelRequire("2YvKC")),
        title: 'Skia Speed Test',
        render: ()=>(0, $jJTNo.html)`<skia-speed-test></skia-speed-test>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.FancyTableDemo]: {
        route: '/dev/fancy-table',
        view: ()=>(parcelRequire("gaERe")),
        title: 'Fancy Table Demo',
        render: ()=>(0, $jJTNo.html)`<fancy-table-demo></fancy-table-demo>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.WizardDemo]: {
        route: '/dev/wizard-demo',
        view: ()=>(parcelRequire("eRxEw")),
        title: 'Wizard Demo',
        render: ()=>(0, $jJTNo.html)`<wizard-demo></wizard-demo>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.HealthCheckDemo]: {
        route: '/dev/health-check-demo',
        view: ()=>(parcelRequire("anUb0")),
        title: 'Health Check Demo',
        render: ()=>(0, $jJTNo.html)`<health-check-demo></health-check-demo>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.MigrateDemo]: {
        route: '/dev/migrate-demo',
        view: ()=>(parcelRequire("eC67O")),
        title: 'Migrate Demo',
        render: ()=>(0, $jJTNo.html)`<migrate-demo></migrate-demo>`
    },
    [$b824ee8513f026d6$export$8a1e4e5afb28371c.PushTool]: {
        route: '/dev/push',
        view: ()=>(parcelRequire("jRk6q")),
        title: 'Push Notifications Tool',
        render: ()=>(0, $jJTNo.html)`<push-tool-view></push-tool-view>`
    }
};

});
parcelRegister("kl35R", function(module, exports) {
module.exports = import("h7Jaf").then(()=>parcelRequire('l7tO7'));

});

parcelRegister("2YvKC", function(module, exports) {
module.exports = Promise.all([
    import("fozYi"),
    import("dyokJ")
]).then(()=>parcelRequire('2whU6'));

});

parcelRegister("gaERe", function(module, exports) {
module.exports = Promise.all([
    import("8tlAZ"),
    import("efCeS")
]).then(()=>parcelRequire('hWFYf'));

});

parcelRegister("eRxEw", function(module, exports) {
module.exports = Promise.all([
    import("1FuD7"),
    import("jTwUT")
]).then(()=>parcelRequire('8JLdQ'));

});

parcelRegister("anUb0", function(module, exports) {
module.exports = import("a7lgv").then(()=>parcelRequire('jmeta'));

});

parcelRegister("eC67O", function(module, exports) {
module.exports = Promise.all([
    import("1FuD7"),
    import("jlg9M")
]).then(()=>parcelRequire('5BCdf'));

});

parcelRegister("jRk6q", function(module, exports) {
module.exports = import("dvfBs").then(()=>parcelRequire('bOyIE'));

});


parcelRegister("lmwUx", function(module, exports) {

$parcel$export(module.exports, "DataTypes", () => $f8d52e798ed929c4$export$fe65d1175fa8eec);
$parcel$export(module.exports, "MODE_IMAGE", () => $f8d52e798ed929c4$export$57dba1229d7af1c9);
$parcel$export(module.exports, "MODE_DOSE", () => $f8d52e798ed929c4$export$9ac65b85c321a1c8);
$parcel$export(module.exports, "MODE_DVF", () => $f8d52e798ed929c4$export$3d75f463ddaf0830);
$parcel$export(module.exports, "TYPE_ACCUMULATED", () => $f8d52e798ed929c4$export$cbcc42bcee3e56b3);
$parcel$export(module.exports, "TYPE_DELIVERED", () => $f8d52e798ed929c4$export$92b44d1f4b5ea9aa);
const $f8d52e798ed929c4$export$fe65d1175fa8eec = {
    ZIP: 'zip',
    DAT: 'dat',
    ZST: 'zst'
};
const $f8d52e798ed929c4$export$57dba1229d7af1c9 = 'image';
const $f8d52e798ed929c4$export$9ac65b85c321a1c8 = 'dose';
const $f8d52e798ed929c4$export$3d75f463ddaf0830 = 'dvf';
const $f8d52e798ed929c4$export$cbcc42bcee3e56b3 = 'accumulated';
const $f8d52e798ed929c4$export$92b44d1f4b5ea9aa = 'delivered';

});

parcelRegister("ekDVr", function(module, exports) {

$parcel$export(module.exports, "isCompletedStatus", () => $a6f1e75434e87dbf$export$15150ef552934472);
$parcel$export(module.exports, "isEndOfTreatmentStatus", () => $a6f1e75434e87dbf$export$6b293b356fe19fb0);
$parcel$export(module.exports, "PRODUCT_NAME", () => $a6f1e75434e87dbf$export$a75e537c279a265a);
$parcel$export(module.exports, "ACCESS_WEEKLY_PERMISSION", () => $a6f1e75434e87dbf$export$d92d5a19f2fcea22);
$parcel$export(module.exports, "SETTINGS_PERMISSION", () => $a6f1e75434e87dbf$export$e6f068df6730be57);
$parcel$export(module.exports, "APPROVE_PERMISSION", () => $a6f1e75434e87dbf$export$1ca7df2bae02a8d4);
$parcel$export(module.exports, "RESEARCH_PERMISSION", () => $a6f1e75434e87dbf$export$3e5227fa55d0128e);
$parcel$export(module.exports, "BATCH_PERMISSION", () => $a6f1e75434e87dbf$export$e7c847e8800e783a);
$parcel$export(module.exports, "BATCH_SETTINGS_PERMISSION", () => $a6f1e75434e87dbf$export$447294c16ee36e9d);
$parcel$export(module.exports, "ASSIGN_CHECK_TEMPLATE_PERMISSION", () => $a6f1e75434e87dbf$export$8192273b6b80838d);
$parcel$export(module.exports, "statuses", () => $a6f1e75434e87dbf$export$cfd07d0d262760eb);
$parcel$export(module.exports, "states", () => $a6f1e75434e87dbf$export$b782dad1d219cf26);
$parcel$export(module.exports, "statusFilters", () => $a6f1e75434e87dbf$export$10a5b9ba02532d9c);
$parcel$export(module.exports, "stateFilters", () => $a6f1e75434e87dbf$export$f4ce98a336a8c3e2);
$parcel$export(module.exports, "FilterModes", () => $a6f1e75434e87dbf$export$50b80da32a015682);
$parcel$export(module.exports, "DateOptions", () => $a6f1e75434e87dbf$export$d1569bdbcc002d20);
const $a6f1e75434e87dbf$export$92cb21f956bf5028 = (status)=>status?.toLowerCase() === 'initial';
const $a6f1e75434e87dbf$export$325028d7aade62c5 = (status)=>status?.toLowerCase() === 'weekly';
const $a6f1e75434e87dbf$export$15150ef552934472 = (status)=>status?.toLowerCase() === 'completed';
const $a6f1e75434e87dbf$export$6b293b356fe19fb0 = (status)=>status?.toLowerCase() === 'endOfTreatment'.toLowerCase();
const $a6f1e75434e87dbf$export$a75e537c279a265a = 'ChartCheck'; // should match the server
const $a6f1e75434e87dbf$export$d92d5a19f2fcea22 = 'CHARTCHECK_CAN_ACCESS_WEEKLY_CHECK';
const $a6f1e75434e87dbf$export$e6f068df6730be57 = 'CHARTCHECK_CAN_EDIT_WEEKLY_CHECK_SETTINGS';
const $a6f1e75434e87dbf$export$1ca7df2bae02a8d4 = 'CHARTCHECK_CAN_APPROVE_WEEKLY_CHECK';
const $a6f1e75434e87dbf$export$3e5227fa55d0128e = 'CHARTCHECK_CAN_ACCESS_RESEARCH_MODE';
const $a6f1e75434e87dbf$export$e7c847e8800e783a = 'CHARTCHECK_CAN_BATCH_APPROVE';
const $a6f1e75434e87dbf$export$447294c16ee36e9d = 'CHARTCHECK_CAN_EDIT_BATCH_SETTINGS';
const $a6f1e75434e87dbf$export$8192273b6b80838d = 'CHARTCHECK_CAN_APPROVE_WEEKLY_CHECK';
const $a6f1e75434e87dbf$export$cfd07d0d262760eb = {
    initial: 'First Weekly Check',
    weekly: 'Weekly Chart Check',
    endOfTreatment: 'EoT Chart Check',
    completed: 'Completed',
    checkedToday: 'Checked Today'
};
const $a6f1e75434e87dbf$export$b782dad1d219cf26 = {
    pass: 'Pass',
    fail: 'Fail',
    condition: 'Condition',
    override: 'Override'
};
const $a6f1e75434e87dbf$export$10a5b9ba02532d9c = [
    'initial',
    'weekly',
    'endOfTreatment',
    'completed',
    'checkedToday'
];
const $a6f1e75434e87dbf$export$f4ce98a336a8c3e2 = [
    'pass',
    'fail',
    'condition',
    'override'
];
const $a6f1e75434e87dbf$export$50b80da32a015682 = {
    PATIENT: 'patient',
    DATE: 'date',
    IMPORT: 'import'
};
const $a6f1e75434e87dbf$export$d1569bdbcc002d20 = Object.entries({
    THIS_WEEK: {
        text: 'Last 7 Days',
        start: -7,
        end: 0
    },
    LAST_TWO_WEEKS: {
        text: 'Last 14 Days',
        start: -14,
        end: 0
    },
    THIS_MONTH: {
        text: 'Last 30 Days',
        start: -30,
        end: 0
    },
    CUSTOM: {
        text: 'Custom Range',
        custom: true
    }
}).reduce((result, [key, value])=>({
        ...result,
        [key]: {
            key: key,
            ...value
        }
    }), {});

});

parcelRegister("h1bTJ", function(module, exports) {
module.exports = Promise.all([
    import("VfNzf"),
    import("dy5CC"),
    import("240ai"),
    import("lPdHB"),
    import("8tlAZ"),
    import("cEwXi"),
    import("9ZuJW"),
    import("f0Vyn"),
    import("hGlNt")
]).then(()=>parcelRequire('cbRN2'));

});

parcelRegister("45Pkd", function(module, exports) {
module.exports = Promise.all([
    import("VfNzf"),
    import("dy5CC"),
    import("9ZuJW"),
    import("240ai"),
    import("laDj4")
]).then(()=>parcelRequire('l9w6w'));

});

parcelRegister("cMErj", function(module, exports) {
module.exports = Promise.all([
    import("lPdHB"),
    import("3tGxz")
]).then(()=>parcelRequire('hBS84'));

});

parcelRegister("h6uha", function(module, exports) {
module.exports = Promise.all([
    import("cEwXi"),
    import("9ZuJW"),
    import("f0Vyn")
]).then(()=>parcelRequire('1n3Xn'));

});

parcelRegister("bEmB9", function(module, exports) {
module.exports = import("cDAc7").then(()=>parcelRequire('5TkQv'));

});

parcelRegister("bJq1a", function(module, exports) {
module.exports = import("3rzX7").then(()=>parcelRequire('ktuva'));

});

parcelRegister("b7hXe", function(module, exports) {
module.exports = Promise.all([
    import("dy5CC"),
    import("9ZuJW"),
    import("eHs8j")
]).then(()=>parcelRequire('az90d'));

});

parcelRegister("10W5X", function(module, exports) {
module.exports = Promise.all([
    import("dy5CC"),
    import("9ZuJW"),
    import("iF61x")
]).then(()=>parcelRequire('fb7mu'));

});

parcelRegister("5K5zE", function(module, exports) {
module.exports = Promise.all([
    import("dy5CC"),
    import("9ZuJW"),
    import("gEEBJ")
]).then(()=>parcelRequire('bqsMj'));

});

parcelRegister("gPUTI", function(module, exports) {
module.exports = import("2gm4U").then(()=>parcelRequire('k3K1x'));

});

parcelRegister("h3KHP", function(module, exports) {
module.exports = import("5Z6NH").then(()=>parcelRequire('bPywh'));

});

parcelRegister("hImB1", function(module, exports) {
module.exports = import("bq3xn").then(()=>parcelRequire('20TqA'));

});

parcelRegister("igtwO", function(module, exports) {
module.exports = Promise.all([
    import("dy5CC"),
    import("9ZuJW"),
    import("240ai"),
    import("2qib2")
]).then(()=>parcelRequire('bJFI8'));

});

parcelRegister("6V5Ja", function(module, exports) {
module.exports = Promise.all([
    import("cEwXi"),
    import("fozYi"),
    import("3gXgN")
]).then(()=>parcelRequire('bGHy8'));

});

parcelRegister("gWdO2", function(module, exports) {
module.exports = import("gaZBU").then(()=>parcelRequire('lQpTR'));

});

parcelRegister("cgO50", function(module, exports) {
module.exports = import("ewggh").then(()=>parcelRequire('6surS'));

});


parcelRegister("1XhrH", function(module, exports) {

$parcel$export(module.exports, "getDefaultParam", () => $16c8d57d3d0deb73$export$ed132113daf4bcc3);

var $8FBvR = parcelRequire("8FBvR");
const $16c8d57d3d0deb73$export$ed132113daf4bcc3 = (paramName)=>{
    switch(paramName){
        case 'organization':
            return (0, $8FBvR.organizationSelector)();
        case 'patientId':
            return (0, $8FBvR.patientIdSelector)();
        case 'patientSer':
            return (0, $8FBvR.patientSerSelector)();
        case 'organizationId':
            return (0, $8FBvR.organizationIdSelector)();
    }
};

});

parcelRegister("kL15l", function(module, exports) {

$parcel$export(module.exports, "disableVerify", () => $f1c909f163fa7b25$export$6ab5d8595c27f54c);
$parcel$export(module.exports, "enableVerify", () => $f1c909f163fa7b25$export$9d2dc33939c8435);
$parcel$export(module.exports, "showOverlay", () => $f1c909f163fa7b25$export$85f1bfb258290b46);
$parcel$export(module.exports, "hideOverlay", () => $f1c909f163fa7b25$export$e7f12c9836083937);
$parcel$export(module.exports, "updateConfig", () => $f1c909f163fa7b25$export$2eaf9172a83ee9e7);
$parcel$export(module.exports, "updateMe", () => $f1c909f163fa7b25$export$8ddaddf355aae59c);
$parcel$export(module.exports, "updateSettings", () => $f1c909f163fa7b25$export$f558026a994b6051);
$parcel$export(module.exports, "updateImageQueuePatientStatus", () => $f1c909f163fa7b25$export$3a503d710f2ef3ec);
$parcel$export(module.exports, "updatePatient", () => $f1c909f163fa7b25$export$a4237eede6ad7dfc);
$parcel$export(module.exports, "updateSystemSettings", () => $f1c909f163fa7b25$export$e243fcda9e628471);
$parcel$export(module.exports, "navigate", () => $f1c909f163fa7b25$export$ff7962acd6052c28);
$parcel$export(module.exports, "authorize", () => $f1c909f163fa7b25$export$be1f35f80d3e29cc);

var $fp8Uu = parcelRequire("fp8Uu");
const $f1c909f163fa7b25$export$6ab5d8595c27f54c = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.VERIFY_DISABLED),
            disabled: true
        });
    };
const $f1c909f163fa7b25$export$9d2dc33939c8435 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.VERIFY_DISABLED),
            disabled: false
        });
    };
const $f1c909f163fa7b25$export$85f1bfb258290b46 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.SHOW_OVERLAY),
            show: true
        });
    };
const $f1c909f163fa7b25$export$e7f12c9836083937 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.SHOW_OVERLAY),
            show: false
        });
    };
const $f1c909f163fa7b25$export$2eaf9172a83ee9e7 = (config)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_CONFIG),
            config: config
        });
    };
const $f1c909f163fa7b25$export$8ddaddf355aae59c = (me)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_ME),
            me: me
        });
    };
const $f1c909f163fa7b25$export$f558026a994b6051 = (settings)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_SETTINGS),
            settings: settings
        });
    };
const $f1c909f163fa7b25$export$3a503d710f2ef3ec = (imageQueuePatientStatus)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_IMAGE_QUEUE_PATIENT_STATUS),
            imageQueuePatientStatus: imageQueuePatientStatus
        });
    };
const $f1c909f163fa7b25$export$a4237eede6ad7dfc = (patient)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_PATIENT),
            patient: patient
        });
    };
const $f1c909f163fa7b25$export$e243fcda9e628471 = (systemSettings)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_SYSTEM_SETTINGS),
            systemSettings: systemSettings
        });
    };
const $f1c909f163fa7b25$export$ff7962acd6052c28 = (page, loadFile, params, query, requiresAuth)=>(dispatch)=>{
        loadFile();
        dispatch({
            type: (0, $fp8Uu.UPDATE_PAGE),
            page: page,
            params: params,
            query: query,
            requiresAuth: requiresAuth
        });
    };
const $f1c909f163fa7b25$export$be1f35f80d3e29cc = (page, granted)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.AUTHORIZE_PAGE),
            page: page,
            granted: granted
        });
    };

});
parcelRegister("fp8Uu", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CONFIG", () => $b3701a32abace423$export$b36bed5c06ca1f9b);
$parcel$export(module.exports, "UPDATE_ME", () => $b3701a32abace423$export$1f3634c85f4bf706);
$parcel$export(module.exports, "UPDATE_SETTINGS", () => $b3701a32abace423$export$da91ee1924d359b9);
$parcel$export(module.exports, "UPDATE_IMAGE_QUEUE_PATIENT_STATUS", () => $b3701a32abace423$export$4915ce1f68db51f8);
$parcel$export(module.exports, "UPDATE_PAGE", () => $b3701a32abace423$export$5744b2ac2f7f4850);
$parcel$export(module.exports, "UPDATE_PATIENT", () => $b3701a32abace423$export$f6cdc6e4a4a3c80a);
$parcel$export(module.exports, "UPDATE_SYSTEM_SETTINGS", () => $b3701a32abace423$export$29dbcc7a45abba53);
$parcel$export(module.exports, "SHOW_OVERLAY", () => $b3701a32abace423$export$5d387504cf09eee4);
$parcel$export(module.exports, "VERIFY_DISABLED", () => $b3701a32abace423$export$390d3a71c3b3b404);
$parcel$export(module.exports, "AUTHORIZE_PAGE", () => $b3701a32abace423$export$68fc1a75ff504f0);
const $b3701a32abace423$export$b36bed5c06ca1f9b = 'UPDATE_CONFIG';
const $b3701a32abace423$export$1f3634c85f4bf706 = 'UPDATE_ME';
const $b3701a32abace423$export$da91ee1924d359b9 = 'UPDATE_SETTINGS';
const $b3701a32abace423$export$4915ce1f68db51f8 = 'UPDATE_IMAGE_QUEUE_PATIENT_STATUS';
const $b3701a32abace423$export$5744b2ac2f7f4850 = 'UPDATE_PAGE';
const $b3701a32abace423$export$f6cdc6e4a4a3c80a = 'UPDATE_PATIENT';
const $b3701a32abace423$export$29dbcc7a45abba53 = 'UPDATE_SYSTEM_SETTINGS';
const $b3701a32abace423$export$5d387504cf09eee4 = 'SHOW_OVERLAY';
const $b3701a32abace423$export$390d3a71c3b3b404 = 'VERIFY_DISABLED';
const $b3701a32abace423$export$68fc1a75ff504f0 = 'AUTHORIZE_PAGE';

});


parcelRegister("jI9i2", function(module, exports) {

$parcel$export(module.exports, "distinct", () => $e5995528b19ab793$export$983a3b5fb2f7202e);
const $e5995528b19ab793$export$983a3b5fb2f7202e = (arr)=>arr.reduce((result, value)=>result.includes(value) ? result : [
            ...result,
            value
        ], []);

});

parcelRegister("iGpZk", function(module, exports) {

$parcel$export(module.exports, "locationProvider", () => $d9a04eee1e0a2b96$export$6382dd7f8145db1c);

var $1pb1q = parcelRequire("1pb1q");

var $iXmyP = parcelRequire("iXmyP");

var $6i2Q5 = parcelRequire("6i2Q5");
class $d9a04eee1e0a2b96$export$5af065edda80e75c {
    constructor(locationObject = location){
        this.locationObject = locationObject;
    }
    get hash() {
        return this.locationObject.hash;
    }
    set hash(value) {
        if (value && !value.startsWith('#')) value = `#${value}`;
        this.locationObject.hash = value;
    }
    get search() {
        return this.locationObject.search;
    }
    set search(value) {
        if (value && !value.startsWith('?')) value = `?${value}`;
        this.locationObject.search = value;
    }
    get pathname() {
        return this.locationObject.pathname;
    }
    set pathname(value) {
        this.locationObject.pathname = value;
    }
    get href() {
        return this.locationObject.href;
    }
    set href(value) {
        this.locationObject.href = value;
    }
    get queryParams() {
        return (0, $iXmyP.getQueryParams)(this.search);
    }
    getQueryParam(queryParam) {
        return (0, $1pb1q.getQueryParam)(queryParam, this.search);
    }
    setQueryParam(queryParam, value) {
        const { queryParams: queryParams } = this;
        queryParams[queryParam] = value;
        this.search = (0, $6i2Q5.toQueryString)(queryParams);
    }
    reload() {
        this.locationObject.reload();
    }
}
const $d9a04eee1e0a2b96$export$6382dd7f8145db1c = new $d9a04eee1e0a2b96$export$5af065edda80e75c();

});
parcelRegister("1pb1q", function(module, exports) {

$parcel$export(module.exports, "getQueryParam", () => $1060acfbfb821719$export$95fd5664a53dd0c5);

var $iXmyP = parcelRequire("iXmyP");
const $1060acfbfb821719$export$95fd5664a53dd0c5 = (name, search)=>(0, $iXmyP.getQueryParams)(search)[name];

});
parcelRegister("iXmyP", function(module, exports) {

$parcel$export(module.exports, "getQueryParams", () => $dccf3ccd9362104d$export$e2de15bbd9edf9c6);

var $iGpZk = parcelRequire("iGpZk");
const $dccf3ccd9362104d$export$e2de15bbd9edf9c6 = (search)=>{
    search ??= (0, $iGpZk.locationProvider).search;
    return search.length ? search.slice(1).split(/&/g).map((v)=>v.split(/=/)).reduce((obj, [key, value])=>// if value is undefined, it means it's a boolean parameter, so we'll just put true
        Object.assign(obj, {
            [key]: value !== null && value !== void 0 ? value : true
        }), {}) : {};
};

});


parcelRegister("6i2Q5", function(module, exports) {

$parcel$export(module.exports, "toQueryString", () => $4946a04a0984dfdd$export$249cc09c933c4d7a);
const $4946a04a0984dfdd$export$249cc09c933c4d7a = (params)=>{
    const str = Object.entries(params).filter(([, value])=>value !== false).map(([key, value])=>value === true ? key : `${key}=${value}`).join('&');
    return str ? `?${str}` : '';
};

});


parcelRegister("11FeY", function(module, exports) {

$parcel$export(module.exports, "RadHttpError", () => $0bf5dff6c80823c0$export$b827343e6abc1eb0);
$parcel$export(module.exports, "radHttp", () => $0bf5dff6c80823c0$export$dce9833de62dfe59);

var $3HT2L = parcelRequire("3HT2L");

var $d1uMe = parcelRequire("d1uMe");

var $4hATe = parcelRequire("4hATe");
function $0bf5dff6c80823c0$var$_defineProperty(e, r, t) {
    return (r = $0bf5dff6c80823c0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0bf5dff6c80823c0$var$_toPropertyKey(t) {
    var i = $0bf5dff6c80823c0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0bf5dff6c80823c0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0bf5dff6c80823c0$var$knownTypes = [
    'json',
    'blob',
    'text',
    'arrayBuffer'
];
class $0bf5dff6c80823c0$export$b827343e6abc1eb0 extends Error {
    constructor(response, message){
        super(message || response?.error?.message);
        $0bf5dff6c80823c0$var$_defineProperty(this, "response", undefined);
        this.response = response;
    }
}
class $0bf5dff6c80823c0$export$3a3d5f78f0853e0b {
    constructor(){
        /**
     * @typedef {'json'|'blob'|'text'|'raw'|'arrayBuffer'} RadHttpRequestType
     */ /**
     * @typedef RadHttpOptions
     * @property {Object.<string, *>} headers= Key/value pairs for headers to send with the request.
     * @property {*} [body] The body to pass along with the request. If it is an object, it will be JSON strinigified.
     *   Use rawBody if you want to avoid stringification. Do not use with rawBody.
     * @property {*} [rawBody] The raw body to be passed along exactly as is. Do not use with body.
     * @property {Object.<string, string|number|boolean>} [query={}] Key/value pairs to make up the querystring.
     * @property {Object.<string, *>} [params={}]
     * @property {RadHttpRequestType} [type='json'] The expected type of the response.
     *   If the expected type does not line up with the expected type, an error is thrown.
     *   If 'raw' is specified, the HttpResponse will have an undefined data and it won't be parsed, so it can be
     *     parsed by the user.
     * @property {Object} [fetchOptions={}] Additional options to be passed to fetch directly.
     * @property {boolean} [debounce=false] If true and another request comes in with the same debounce name, previous
     *   calls will complete with no response and debounced = true
     * @property {string} [debounceName] Defaults to the url of the request, without parameters substituted.
     * @property {function(RadHttpResponse)} [responseHandler] A method that is called before the response is returned.
     * @property {boolean} [force=false] If true, the URL will have a cache-busting string appended.
     */ /**
     * @typedef RadHttpResponse
     * @template T
     * @property {string} url The actual URL given to fetch.
     * @property {Object} options The actual options given to fetch.
     * @property {Response} response The response from fetch()
     * @property {?T} data The parsed data, parsed based on the type,
     *   using either .json(), .blob() or .text()
     * @property {'json'|'blob'|'text'} type
     *  The type of response. It is based on the Content-Type and matches the following:
     *   - application/json => json
     *   - text/* => text
     *   - anything else => blob
     *   If RadHttpOptions.type was specified, it is always this value.
     * @property {Error=} error The error produced while attempting the request, or returned by the server.
     *   Only possible from the server if type is JSON.
     * @property {boolean} debounced Indicates if the request was aborted. If true, data will always be undefined.
     * @property {boolean} ok Indicates if the request was successful.
     */ /**
     * Method to get default parameters.
     * @type {function(string):string}
     */ $0bf5dff6c80823c0$var$_defineProperty(this, "getDefaultParam", ()=>'');
        /**
     * A dictionary of debounceNames and their AbortController.
     * @type {Object.<string, AbortController>}
     */ $0bf5dff6c80823c0$var$_defineProperty(this, "debounceControllers", {});
        /**
     * If true, it will not console.error errors
     * @type {Boolean}
     * @default false
     */ $0bf5dff6c80823c0$var$_defineProperty(this, "muted", false);
        /**
     * @type {function(RadHttpResponse)}
     */ $0bf5dff6c80823c0$var$_defineProperty(this, "defaultResponseHandler", ()=>{});
    }
    /**
   * Performs an HTTP request.
   * @param {string} verb
   * @param {string} url The URL, which can contain param keys wrapped in curly brackets.
   *   E.g., /patient/{patientId}
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   *
   * Note: option.type defaults to 'json'. If you want a different type, you'll have to manually specify.
   */ async request(verb, url, { body: body, rawBody: rawBody, headers: headers = {}, rawHeaders: rawHeaders, query: query = {}, params: params = {}, type: type = 'json', fetchOptions: fetchOptions = {}, debounce: debounce = false, debounceName: debounceName, responseHandler: responseHandler, force: force = false } = {}) {
        try {
            var _response$ok;
            if (!verb) throw new Error("Must provide an HTTP verb. Unless you need a custom verb, it is recommended to use the HTTP method functions (get(), put(), post(), delete(), patch()).");
            if (!url) throw new Error('Must provide a URL.');
            if (body !== undefined && rawBody !== undefined) throw new Error('Cannot use "body" and "rawBody" in the same request.');
            if (rawHeaders !== undefined && Object.keys(headers).length) throw new Error('Cannot specify headers on "headers" when using "rawHeaders" in the same request.');
            if (type && !$0bf5dff6c80823c0$var$knownTypes.includes(type)) throw new Error(`Unknown type: ${type}, expected one of: ${$0bf5dff6c80823c0$var$knownTypes.join(', ')}`);
            const actualUrl = this.parseUrl(url, {
                params: params,
                force: force,
                query: query
            });
            const options = {
                headers: rawHeaders !== null && rawHeaders !== void 0 ? rawHeaders : {
                    'Content-Type': 'application/json',
                    ...headers
                },
                body: rawBody !== null && rawBody !== void 0 ? rawBody : typeof body === 'object' ? JSON.stringify(body) : body,
                method: verb,
                ...fetchOptions
            };
            let abortController;
            if (debounce) {
                debounceName ??= url;
                // Debounce the existing request.
                if (this.debounceControllers[debounceName]) this.debounceControllers[debounceName].abort('debounce');
                abortController = new AbortController();
                options.signal = abortController.signal;
                this.debounceControllers[debounceName] = abortController;
            }
            let response;
            let debounced = false;
            try {
                response = await fetch(actualUrl, options);
            } catch (ex) {
                if (typeof ex === 'string' && ex === 'debounce') debounced = true;
                else // noinspection ExceptionCaughtLocallyJS
                throw ex; // something else went wrong, so just throw it again
            }
            let contentType;
            let data;
            let error;
            if (!debounced) {
                [contentType] = response.headers.get('Content-Type')?.split(';') || [];
                if (verb !== 'HEAD' && response.status !== 204 && response.headers.get('Content-Length') !== '0') {
                    try {
                        if ([
                            'application/json',
                            'application/problem+json'
                        ].includes(contentType) && (!type || type === 'json')) {
                            var _result$data;
                            const result = await response.json();
                            type = 'json';
                            data = (_result$data = result?.data) !== null && _result$data !== void 0 ? _result$data : result;
                            error = result?.error;
                        } else if (type === 'text' || !type && (0, $d1uMe.contentTypeMatches)(contentType, 'text/*')) {
                            data = await response.text();
                            type = 'text';
                        } else if (type === 'arrayBuffer') {
                            data = await response.arrayBuffer();
                            type = 'arrayBuffer';
                        } else if (!type || type === 'blob') {
                            data = await response.blob();
                            type = 'blob';
                        }
                    } catch (error) {
                        throw new $0bf5dff6c80823c0$export$b827343e6abc1eb0({
                            response: response,
                            url: actualUrl,
                            options: options,
                            error: error
                        });
                    }
                    if (data === undefined || data === null) throw $0bf5dff6c80823c0$var$_buildTypeMismatchError.call($0bf5dff6c80823c0$export$3a3d5f78f0853e0b, type, contentType, response, url, options);
                }
            }
            if (debounce) delete this.debounceControllers[debounceName];
            const result = {
                url: actualUrl,
                options: options,
                response: response,
                type: type,
                data: data,
                error: error,
                debounced: debounced,
                ok: (_response$ok = response?.ok) !== null && _response$ok !== void 0 ? _response$ok : debounced,
                status: response?.status
            };
            (responseHandler !== null && responseHandler !== void 0 ? responseHandler : this.defaultResponseHandler)?.(result);
            return result;
        } catch (err) {
            if (!this.muted) console.error(err);
            throw err;
        }
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} [options={}]
   * @return {Promise.<RadHttpResponse>}
   */ async get(url, options = {}) {
        return this.request('GET', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async put(url, options = {}) {
        return this.request('PUT', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async post(url, options = {}) {
        return this.request('POST', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async delete(url, options = {}) {
        return this.request('DELETE', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async patch(url, options = {}) {
        return this.request('PATCH', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @returns {Promise<RadHttpResponse>}
   */ async head(url, options = {}) {
        return this.request('HEAD', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @returns {string}
   */ parseUrl(url, { params: params = {}, force: force = false, query: query = {} }) {
        if (force) query[`${Date.now()}${Math.floor(Math.random() * Math.pow(10, 10))}`] = true;
        try {
            return `${(0, $3HT2L.applyParams)(url, params, this.getDefaultParam)}${(0, $4hATe.queryToString)(query)}`;
        } catch (ex) {
            throw new Error(`${ex.message}, URL: ${url}`);
        }
    }
}
/**
 * The main radHttp instance that everything should use.
 * @type {RadHttp}
 */ function $0bf5dff6c80823c0$var$_buildTypeMismatchError(type, contentType, response, url, options) {
    return new $0bf5dff6c80823c0$export$b827343e6abc1eb0({
        response: response,
        url: url,
        options: options,
        type: type
    }, `Response expected type ${type}, but Content-Type was ${contentType} which is not acceptable, for URL: ${url}`);
}
const $0bf5dff6c80823c0$export$dce9833de62dfe59 = new $0bf5dff6c80823c0$export$3a3d5f78f0853e0b();

});
parcelRegister("3HT2L", function(module, exports) {

$parcel$export(module.exports, "applyParams", () => $2b3015bee8556bf1$export$905b1ae8ad2cc267);
const $2b3015bee8556bf1$export$905b1ae8ad2cc267 = (url, params, getDefault)=>url.replace(/{([^}]+)}/g, (_, key)=>{
        var _params$key;
        const value = (_params$key = params?.[key]) !== null && _params$key !== void 0 ? _params$key : getDefault(key);
        if (value === undefined) throw new Error(`Unknown param: ${key}. Known params: ${Object.keys(params).join(', ')}`);
        return value;
    });

});

parcelRegister("d1uMe", function(module, exports) {

$parcel$export(module.exports, "contentTypeMatches", () => $97b33dfd81d91b6e$export$76e2473b636f05e4);
/**
 * Checks if the content type matches the target type.
 * @param {string} contentType The content type to check. Should not have wildcards.
 * @param {string} targetType The target type, which can contain wildcards.
 * @return {boolean}
 */ const $97b33dfd81d91b6e$export$76e2473b636f05e4 = (contentType, targetType)=>{
    if (!contentType) return false;
    const [actualA, actualB] = contentType.toLowerCase().split('/');
    const [targetA, targetB] = targetType.toLowerCase().split('/');
    return (targetA === '*' || actualA === targetA) && (targetB === '*' || actualB === targetB);
};

});

parcelRegister("4hATe", function(module, exports) {

$parcel$export(module.exports, "queryToString", () => $31e55d7c780dc12d$export$78b7a7f99b2aea2d);
/**
 * @param {Object.<string, *>} query The parts of the query to build.
 * @return {string} The constructed string (including the beginning ?) or an empty string if query was empty.
 */ const $31e55d7c780dc12d$export$78b7a7f99b2aea2d = (query)=>{
    if (!query) return '';
    const joined = Object.entries(query !== null && query !== void 0 ? query : {}).filter(([, value])=>value !== undefined && value !== null).map(([key, value])=>typeof value === 'boolean' ? key : `${key}=${value}`).join('&');
    return `${joined.length ? '?' : ''}${joined}`;
};

});


parcelRegister("g8NJW", function(module, exports) {

$parcel$export(module.exports, "getDownloadTypeString", () => $bc03fa038c58635d$export$4178073e5b1d4829);
$parcel$export(module.exports, "downloads", () => $bc03fa038c58635d$export$80996978b5b75575);

var $daUxE = parcelRequire("daUxE");

var $gQPVU = parcelRequire("gQPVU");

var $4pLXR = parcelRequire("4pLXR");

var $11FeY = parcelRequire("11FeY");

var $kYBQo = parcelRequire("kYBQo");

var $3dWLv = parcelRequire("3dWLv");

var $3CBzT = parcelRequire("3CBzT");

var $8FBvR = parcelRequire("8FBvR");
function $bc03fa038c58635d$var$_defineProperty(e, r, t) {
    return (r = $bc03fa038c58635d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bc03fa038c58635d$var$_toPropertyKey(t) {
    var i = $bc03fa038c58635d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $bc03fa038c58635d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $bc03fa038c58635d$export$3fb3781291f9dcb1 = 30000; // ms
const $bc03fa038c58635d$export$adaa5ea94439e8b8 = {
    STARTED: 'Started',
    COMPLETED: 'Completed',
    FAILED: 'Failed'
};
const $bc03fa038c58635d$export$4178073e5b1d4829 = (type, capitalized = false)=>{
    const transform = capitalized ? (0, $3CBzT.capitalize) : (v)=>v;
    switch(type){
        case 'AnonymizedImage':
            return transform('anonymized image');
        case 'AnonymizedPatient':
            return transform('anonymized patient');
        case 'NonAnonymizedImage':
            return transform('non-anonymized image');
        case 'NonAnonymizedPatient':
            return transform('non-anonymized patient');
    }
    return transform('download');
};
class $bc03fa038c58635d$export$2cd53d072e88150f {
    constructor(){
        /** @type {number} */ $bc03fa038c58635d$var$_defineProperty(this, "_pollTimeoutId", void 0);
        /** @type {DownloadManager~listener[]} */ $bc03fa038c58635d$var$_defineProperty(this, "_listeners", []);
        /** @type {DownloadItem[]|undefined} */ $bc03fa038c58635d$var$_defineProperty(this, "_items", undefined);
        /** @type {UserInfo} */ $bc03fa038c58635d$var$_defineProperty(this, "_me", void 0);
        /** @type {function()} */ $bc03fa038c58635d$var$_defineProperty(this, "_unsubscribeStore", void 0);
        $bc03fa038c58635d$var$_defineProperty(this, "_stateChanged", (state)=>{
            this._me = (0, $8FBvR.meSelector)(state);
        });
    }
    async enable() {
        this._unsubscribeStore = (0, $kYBQo.getStore)().subscribe(this._stateChanged);
        await this._poll(true, true, true);
    }
    disable() {
        clearTimeout(this._pollTimeoutId);
        this._unsubscribeStore?.();
        this._unsubscribeStore = undefined;
    }
    /**
   * @param {boolean} [force=false] If true, it will re-poll before returning.
   * @returns {Promise<DownloadItem[]>}
   */ async get(force = false) {
        if (!this._items || force) await this._poll();
        return this._items;
    }
    /**
   * Returns the current list of items filtered by the options.
   *
   * Defaults to providing only completed items with files.
   * @param {DownloadManager~Filter} [filters]
   *  The statuses to include. Give an empty array or undefined to ignore.
   * @param {boolean} [force=false] If true, it will trigger a poll to get the current items.
   * @returns {Promise<DownloadItem[]>} The filtered items.
   */ async filtered(filters = {}, force = false) {
        const statuses = (0, $4pLXR.objectHas)(filters, 'statuses') ? filters.statuses : [
            $bc03fa038c58635d$export$adaa5ea94439e8b8.COMPLETED
        ];
        const hasFile = (0, $4pLXR.objectHas)(filters, 'hasFile') ? filters.hasFile : true;
        const types = (0, $4pLXR.objectHas)(filters, 'types') ? filters.types : [];
        return (await this.get(force)).filter((item)=>(!statuses?.length || statuses?.includes(item.status)) && (!types?.length || types?.includes(item.type)) && (hasFile === undefined || item.hasFile === hasFile));
    }
    /**
   * @param {function(items:DownloadItem[])} callback
   */ addListener(callback) {
        this._listeners.push(callback);
    }
    /**
   * @param {function(items:DownloadItem[])} callback
   */ removeListener(callback) {
        const index = this._listeners.indexOf(callback);
        if (index === -1) return;
        this._listeners.splice(index, 1);
    }
    /**
   * @param {DownloadItem} item
   * @param {string} [extension='zip']
   */ async downloadItem(item, extension = 'zip') {
        if (!item) return;
        const response = await (0, $11FeY.radHttp).get(`./weekly-check/api/support/download/{organization}/${item.id}`, {
            type: 'blob'
        });
        if (response?.ok) this.downloadBlob(response.data, `${item.saveId}.${extension}`);
        else (0, $kYBQo.getStore)().dispatch((0, $3dWLv.addToast)(`There was a problem downloading the ${$bc03fa038c58635d$export$4178073e5b1d4829(item.type)}.`, {
            color: 'var(--bad-color)'
        }));
    }
    /**
   * @param {string} data
   * @param {string} filename
   * @param {string} mimeType
   */ downloadText(data, filename = 'download.txt', mimeType = 'text/plain') {
        this._download(`data:${mimeType};charset=utf-8,${encodeURIComponent(data)}`, filename);
    }
    /**
   * @param {Blob} data
   * @param {string} filename
   */ downloadBlob(data, filename) {
        this._download(window.URL.createObjectURL(data), filename);
    }
    /**
   * @param {Object|string} data
   * @param {string} filename
   */ downloadJson(data, filename = 'download.json') {
        const downloadStr = typeof data === 'object' ? JSON.stringify(data, null, 2) : data;
        this.downloadText(downloadStr, filename, 'application/json');
    }
    _download(dataUrl, filename) {
        const element = document.createElement('a');
        element.setAttribute('href', dataUrl);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    /**
   * @param {boolean} [loop=false] If true, this will kick off the polling loop.
   * @param {boolean} [notify=false] If true, newly completed items will notify users.
   * @param {boolean} [downloadCompleted=false] If true, any newly completed items will download.
   * @returns {Promise}
   * @private
   */ async _poll(loop = false, notify = false, downloadCompleted = false) {
        try {
            const response = await (0, $11FeY.radHttp).get('./weekly-check/api/support/downloads/{organization}');
            if (!response.ok) return;
            await this._processItems(response.data, notify, downloadCompleted);
            if (!(0, $gQPVU.deepEquals)(this._items, response.data)) {
                this._items = response.data.sort((0, $daUxE.sortBy)([
                    'creationDate',
                    -1
                ]));
                for (const listener of this._listeners)listener(this._items);
            }
        } catch (ex) {
            console.error('Error polling downloads', ex);
        }
        if (loop) this._pollTimeoutId = setTimeout(()=>{
            this._poll(true, notify, downloadCompleted);
        }, $bc03fa038c58635d$export$3fb3781291f9dcb1);
    }
    /**
   *
   * @param {boolean} [notify=false] If true, newly completed items will notify users.
   * @param {boolean} [downloadCompleted=false] If true, any newly completed items will download.
   * @param items
   * @param downloadCompleted
   * @returns {Promise<void>}
   * @private
   */ async _processItems(items, notify = false, downloadCompleted = false) {
        if (!this._me) return;
        // Get all the download items that are finished processing that the user hasn't been notified about
        const newlyProcessedItems = items.filter((item)=>item.userId === this._me.chartCheckId && [
                $bc03fa038c58635d$export$adaa5ea94439e8b8.FAILED,
                $bc03fa038c58635d$export$adaa5ea94439e8b8.COMPLETED
            ].includes(item.status) && !item.userNotified).sort((0, $daUxE.sortBy)([
            'creationDate',
            -1
        ]));
        if (notify || downloadCompleted) for (const item of newlyProcessedItems){
            if (item.status === $bc03fa038c58635d$export$adaa5ea94439e8b8.COMPLETED) {
                if (notify) (0, $kYBQo.getStore)().dispatch((0, $3dWLv.addToast)(`Download of ${$bc03fa038c58635d$export$4178073e5b1d4829(item.type)} ready for ${item.lastName}, ${item.firstName} (${item.patientId}). ` + 'Click show available downloads in the info menu to download.'));
                if (downloadCompleted) await this.downloadItem(item);
            } else if (item.status === $bc03fa038c58635d$export$adaa5ea94439e8b8.FAILED) {
                if (notify) (0, $kYBQo.getStore)().dispatch((0, $3dWLv.addToast)(`Failed to create download for ${item.lastName}, ${item.firstName} (${item.patientId}).`, {
                    color: 'var(--bad-color)'
                }));
            }
            if (notify) await (0, $11FeY.radHttp).put(`./weekly-check/api/support/download/{organization}/{itemId}/user-notified`, {
                type: 'blob',
                params: {
                    itemId: item.id
                }
            });
        }
    }
}
const $bc03fa038c58635d$export$80996978b5b75575 = new $bc03fa038c58635d$export$2cd53d072e88150f();

});
parcelRegister("daUxE", function(module, exports) {

$parcel$export(module.exports, "sortBy", () => $9978118c96b459f0$export$b035e44d7bb4278f);
/**
 * @param {string|Array.<string|number>} keys Either a key (sorted ascending)
 *  or a key and number indicating direction ['key', 0] (> 0 is ascending, < 0 is descending)
 * @returns {function(*, *): *} The method to provide to the .sort() to perform the sort.
 * @example sortBy(['key', 1])(arr)
 */ const $9978118c96b459f0$export$b035e44d7bb4278f = (...keys)=>(a, b)=>keys.map((input)=>{
            var _a$key$toLowerCase, _b$key$toLowerCase, _b$key$toLowerCase2, _a$key$toLowerCase2;
            let key;
            let dir = 1; // ascending
            if (typeof input === 'string') key = input;
            else if (Array.isArray(input)) [key, dir] = input;
            else throw new Error(`Invalid key ${key}`);
            return ((_a$key$toLowerCase = a[key]?.toLowerCase?.()) !== null && _a$key$toLowerCase !== void 0 ? _a$key$toLowerCase : a[key]) < ((_b$key$toLowerCase = b[key]?.toLowerCase?.()) !== null && _b$key$toLowerCase !== void 0 ? _b$key$toLowerCase : b[key]) ? -dir : ((_b$key$toLowerCase2 = b[key]?.toLowerCase?.()) !== null && _b$key$toLowerCase2 !== void 0 ? _b$key$toLowerCase2 : b[key]) < ((_a$key$toLowerCase2 = a[key]?.toLowerCase?.()) !== null && _a$key$toLowerCase2 !== void 0 ? _a$key$toLowerCase2 : a[key]) ? dir : 0;
        }).find((r)=>r) || 0;

});

parcelRegister("gQPVU", function(module, exports) {

$parcel$export(module.exports, "deepEquals", () => $c449c97970f0cac9$export$73ce4178444047a5);
const $c449c97970f0cac9$export$73ce4178444047a5 = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && Object.keys(a).length === Object.keys(b).length && Object.entries(a).every(([key, aValue])=>$c449c97970f0cac9$export$73ce4178444047a5(aValue, b[key]));

});

parcelRegister("4pLXR", function(module, exports) {

$parcel$export(module.exports, "objectHas", () => $336eb3fa4aa446cc$export$6d9d977b2dc588fb);
/**
 * Returns true if the object has a given property, even if that property is falsy.
 * @param {Object} obj
 * @param {string} propertyName
 * @returns {boolean}
 */ const $336eb3fa4aa446cc$export$6d9d977b2dc588fb = (obj, propertyName)=>{
    while(obj){
        if (Object.getOwnPropertyDescriptor(obj, propertyName)) return true;
        obj = Object.getPrototypeOf(obj);
    }
    return false;
};

});

parcelRegister("3dWLv", function(module, exports) {

$parcel$export(module.exports, "addToast", () => $25902b85bf9073fc$export$2cb648f4e71e8121);

var $4XuZH = parcelRequire("4XuZH");

var $3S5XD = parcelRequire("3S5XD");

var $4gjhp = parcelRequire("4gjhp");
const $25902b85bf9073fc$export$2cb648f4e71e8121 = (message, { color: color = '#27AE60', timeout: timeout = 5, id: id = (0, $3S5XD.randomString)(24) } = {})=>(dispatch)=>{
        setTimeout(()=>{
            dispatch({
                type: (0, $4gjhp.UPDATE_TOAST),
                id: id,
                state: (0, $4XuZH.ToastStates).STATIC
            });
        }, 1);
        setTimeout(()=>{
            dispatch({
                type: (0, $4gjhp.UPDATE_TOAST),
                id: id,
                state: (0, $4XuZH.ToastStates).FADE_OUT
            });
        }, ((0, $4XuZH.TOAST_FADE_IN_DURATION) + timeout) * 1000);
        setTimeout(()=>{
            dispatch({
                type: (0, $4gjhp.CLEAR_TOAST),
                id: id
            });
        }, (timeout + (0, $4XuZH.TOAST_FADE_IN_DURATION) + (0, $4XuZH.TOAST_FADE_OUT_DURATION)) * 1000);
        dispatch({
            type: (0, $4gjhp.ADD_TOAST),
            id: id,
            message: message,
            color: color,
            state: (0, $4XuZH.ToastStates).FADE_IN
        });
    };

});
parcelRegister("4XuZH", function(module, exports) {

$parcel$export(module.exports, "TOAST_FADE_IN_DURATION", () => $39c4b6e67c3dd337$export$8df0c72fdf02f254);
$parcel$export(module.exports, "TOAST_FADE_OUT_DURATION", () => $39c4b6e67c3dd337$export$68acf6e8a1bbd258);
$parcel$export(module.exports, "ToastStates", () => $39c4b6e67c3dd337$export$89f60cc3127d0bf5);
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");
parcelRequire("kbnNu");
var $a1Xkc = parcelRequire("a1Xkc");

var $a2cIB = parcelRequire("a2cIB");

var $kYBQo = parcelRequire("kYBQo");

var $9xDAL = parcelRequire("9xDAL");

var $hoKml = parcelRequire("hoKml");
function $39c4b6e67c3dd337$var$_defineProperty(e, r, t) {
    return (r = $39c4b6e67c3dd337$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39c4b6e67c3dd337$var$_toPropertyKey(t) {
    var i = $39c4b6e67c3dd337$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $39c4b6e67c3dd337$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $39c4b6e67c3dd337$export$8df0c72fdf02f254 = .33;
const $39c4b6e67c3dd337$export$68acf6e8a1bbd258 = .33;
const $39c4b6e67c3dd337$export$89f60cc3127d0bf5 = {
    FADE_IN: 'fade-in',
    STATIC: 'static',
    FADE_OUT: 'fade-out'
};
class $39c4b6e67c3dd337$export$b0fefddcdd8aa9ad extends (0, $a2cIB.connect)((0, $kYBQo.getStore))((0, $lPSdM.LitElement)) {
    render() {
        const { toasts: toasts = [] } = this;
        return (0, $jJTNo.html)`
    ${toasts.map(({ message: message, state: state, color: color })=>(0, $jJTNo.html)`
      <toast-banner class=${state} style=${(0, $a1Xkc.styleMap)({
                background: color
            })}>
        <b>
          ${message}
        </b>
      </toast-banner>
    `)}
  `;
    }
    stateChanged(state) {
        this.toasts = (0, $9xDAL.toastsSelector)(state);
    }
}
$39c4b6e67c3dd337$var$_defineProperty($39c4b6e67c3dd337$export$b0fefddcdd8aa9ad, "styles", [
    (0, $hoKml.commonStyles),
    (0, $4jdI8.css)`
      :host {
        position: fixed;
        display: flex;
        flex-direction: column-reverse;
        bottom: 8px;
        right: 0;
        top: 0;
        left: 0;
        z-index: 9999;
        align-items: flex-end;
        pointer-events: none;
      }

      toast-banner {
        position: relative;
        text-align: center;
        width: 100%;
        padding: 12px 16px;
        margin: 8px 16px;
        max-width: 360px;
        opacity: 0;
        color: #FFFFFF;
        background: #333;
        font-size: 13px;
        border-radius: 5px;
        box-shadow: 0 8px 16px rgba(49,60,67,.24);
        transition: .33s opactiy;
      }
      
      toast-banner.static {
        opacity: 1;
      }
    `
]);
$39c4b6e67c3dd337$var$_defineProperty($39c4b6e67c3dd337$export$b0fefddcdd8aa9ad, "properties", {
    toasts: {
        type: Array
    }
});
customElements.define('toasts-container', $39c4b6e67c3dd337$export$b0fefddcdd8aa9ad);

});
parcelRegister("kbnNu", function(module, exports) {
$parcel$export(module.exports, "styleMap", () => (parcelRequire("a1Xkc")).styleMap);
parcelRequire("a1Xkc");

});
parcelRegister("a1Xkc", function(module, exports) {

$parcel$export(module.exports, "styleMap", () => $74d80410d825d70d$export$1e5b4ce2fa884e6a);

var $jJTNo = parcelRequire("jJTNo");

var $57ByJ = parcelRequire("57ByJ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $74d80410d825d70d$var$n = "important", $74d80410d825d70d$var$i = " !" + $74d80410d825d70d$var$n, $74d80410d825d70d$export$1e5b4ce2fa884e6a = (0, $57ByJ.directive)(class extends (0, $57ByJ.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $57ByJ.PartType).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($74d80410d825d70d$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $74d80410d825d70d$var$n : "") : s[t] = e;
            }
        }
        return 0, $jJTNo.noChange;
    }
});

});
parcelRegister("57ByJ", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $3baabda811939da5$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $3baabda811939da5$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $3baabda811939da5$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("a2cIB", function(module, exports) {

$parcel$export(module.exports, "connect", () => $74e3f4df54e7656c$export$64605811ab45167f);
function $74e3f4df54e7656c$var$_classPrivateFieldInitSpec(e, t, a) {
    $74e3f4df54e7656c$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $74e3f4df54e7656c$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $74e3f4df54e7656c$var$_classPrivateFieldSet(s, a, r) {
    return s.set($74e3f4df54e7656c$var$_assertClassBrand(s, a), r), r;
}
function $74e3f4df54e7656c$var$_classPrivateFieldGet(s, a) {
    return s.get($74e3f4df54e7656c$var$_assertClassBrand(s, a));
}
function $74e3f4df54e7656c$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
const $74e3f4df54e7656c$export$64605811ab45167f = (storeOrStoreGetter)=>(BaseClass)=>{
        const getStore = typeof storeOrStoreGetter === 'function' ? storeOrStoreGetter : ()=>storeOrStoreGetter;
        var _lastState = /*#__PURE__*/ new WeakMap();
        var _unsubscribe = /*#__PURE__*/ new WeakMap();
        var _handleChange = /*#__PURE__*/ new WeakMap();
        class Connected extends BaseClass {
            constructor(...args){
                super(...args);
                $74e3f4df54e7656c$var$_classPrivateFieldInitSpec(this, _lastState, void 0);
                $74e3f4df54e7656c$var$_classPrivateFieldInitSpec(this, _unsubscribe, void 0);
                $74e3f4df54e7656c$var$_classPrivateFieldInitSpec(this, _handleChange, ()=>{
                    const state = getStore().getState();
                    this.stateChanged(state, $74e3f4df54e7656c$var$_classPrivateFieldGet(_lastState, this));
                    $74e3f4df54e7656c$var$_classPrivateFieldSet(_lastState, this, state);
                });
            }
            connectedCallback() {
                const store = getStore();
                $74e3f4df54e7656c$var$_classPrivateFieldSet(_lastState, this, store.getState());
                $74e3f4df54e7656c$var$_classPrivateFieldSet(_unsubscribe, this, store.subscribe($74e3f4df54e7656c$var$_classPrivateFieldGet(_handleChange, this)));
                this.stateChanged(store.getState(), {});
                super.connectedCallback();
            }
            disconnectedCallback() {
                $74e3f4df54e7656c$var$_classPrivateFieldGet(_unsubscribe, this) && $74e3f4df54e7656c$var$_classPrivateFieldGet(_unsubscribe, this).call(this);
                $74e3f4df54e7656c$var$_classPrivateFieldSet(_unsubscribe, this, undefined);
                super.disconnectedCallback();
            }
            // eslint-disable-next-line no-unused-vars
            stateChanged(currentState, previousState) {}
        }
        return Connected;
    };

});

parcelRegister("9xDAL", function(module, exports) {

$parcel$export(module.exports, "toastsSelector", () => $6f25e846726d1d7e$export$31b4d656fe8b34d0);

var $eGMym = parcelRequire("eGMym");
const $6f25e846726d1d7e$export$31b4d656fe8b34d0 = (0, $eGMym.createSelector)('toasts.toasts');

});

parcelRegister("hoKml", function(module, exports) {

$parcel$export(module.exports, "commonStyles", () => $caa8a38ea87566bc$export$e8ccb531c7793070);
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");

var $aXDrb = parcelRequire("aXDrb");
const $caa8a38ea87566bc$export$e8ccb531c7793070 = [
    (0, $aXDrb.fontAwesomeStyles),
    (0, $4jdI8.css)`
    :host {
      --blue-1: #184664;
      --blue-2: #266FA0;
      --blue-3: #3498DB;
      --blue-4: #62B6ED;
      --blue-5: #9CD1F4;
      --blue-6: #D8ECFA;
      --blue-7: #EAF5FD;
  
      --neutral-1: #1E252A;
      --neutral-2: #313C43;
      --neutral-3: #42525C;
      --neutral-4: #6B8393;
      --neutral-5: #A2B2BC;
      --neutral-6: #DAE0E4;
      --neutral-7: #ECF0F2;
      --neutral-8: #F6F8F9;
      --neutral-9: #F9FAFB;
      --neutral-10: #FFFFFF;
  
      --green-1: #12502C;
      --green-2: #1D7F46;
      --green-3: #27AE60;
      --green-4: #61C48B;
      --green-5: #9CDAB6;
      --green-6: #D7F0E2;
      --green-7: #EBF7F0;
  
      --orange-1: #522900;
      --orange-2: #a54700;
      --orange-3: #FF9900;
      --orange-4: #FFBB00;
      --orange-5: #FFCC33;
      --orange-6: #FFDD66;
      --orange-7: #FFEE99;
  
      --primary-1: var(--blue-1);
      --primary-2: var(--blue-2);
      --primary-3: var(--blue-3);
      --primary-4: var(--blue-4);
      --primary-5: var(--blue-5);
      --primary-6: var(--blue-6);
      --primary-7: var(--blue-7);
  
      --primary-color: var(--primary-3);
      --secondary-color: var(--neutral-4);
      --side-background: var(--neutral-8);
      --side-border: var(--neutral-6);
      --hover-color: var(--neutral-7);
      --good-color: var(--green-3);
      --bad-color: #F00;
      --light-color: #FFF;
      --dark-color: var(--neutral-3);
      --darker-color: var(--neutral-1);
      --selected-color: var(--primary-color);
      --button-hover-color: var(--blue-2);
    }
  
    :host * {
      box-sizing: border-box;
    }
  
    button {
      font-size: 15px;
      font-weight: 400;
      padding: 12px 24px;
      transition: all .25s;
    }
  
    button:focus {
      outline: none;
    }
  
    section {
      margin: 0 16px 24px 0;
      box-shadow: 0 4px 6px var(--neutral-6);
      border-radius: 5px;
      display: inline-block;
      min-width: 100%;
    }
  
    section header h4,
    section,
    section > table,
    section > table > thead {
      background: var(--light-color);
    }
  
    section > table > thead {
      background: var(--neutral-8);
    }
    
    input.filter,
    select.filter {
      background-image: url("images/filled-filter-icon_gray.svg");
      background-repeat: no-repeat;
      background-size: 1.6em;
      background-position: 5px center;
      padding-left: 29px !important;
    }
    
    input.filter.filter-smaller,
    select.filter.filter-smaller {
      background-size: 1.2em;
      padding-left: 25px !important;
    }
  
    .four-oh {
      width: 60%;
      text-align: center;
      padding: 32px 32px 48px;
      font-size: 1.1rem;
      margin: 72px auto auto;
      color: var(--neutral-2);
      max-width: 720px;
      background: white;
    }
  
    .four-oh.modal {
      padding: 48px 32px 48px;
      background: var(--neutral-8);
      border-radius: 5px;
      border: var(--neutral-7);
      box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
    }
  
    .four-oh.modal a {
      color: #3498DB;
      text-decoration: none;
      cursor: pointer;
    }
  
    .four-oh i {
      margin-top: 16px;
      color: var(--blue-3);
    }
  
    #refresh-area {
      flex: 0 0 250px;
      display: flex;
      align-items: center;
    }
    
    #refresh-area i {
      color: var(--primary-color);
      margin: 2px 8px 0 0;
      font-size: 17px;
      text-align: right;
    }
  
    #refresh-area ul {
      white-space: nowrap;
      padding: 0;
      list-style: none;
      margin: 0;
      text-align: right;
    }
    
    #refresh-area i {
      cursor: pointer;
    }
    
    .min-content {
      width: min-content;
      
      :where(td, th)& {
        width: 1%;
        white-space: nowrap;
      }
    }
    
    .text-center {
      text-align: center;
    }
    
    .nowrap {
      white-space: nowrap;
    }
    
    .support button,
    .support .btn,
    button.support,
    .support.btn {
      display: block;
      background: #3498DB;
      color: #FFF;
      padding: 8px 16px;
      border: 0;
      margin: 8px auto;
      cursor: pointer;
      text-decoration:none;
      font-size: 13px;
      
      &:hover {
        background: #266FA0;
      }
      
      &[disabled] {
        cursor: default;
        background: var(--neutral-4);
      }
    }
    
    .indicator {
      position: absolute;
      background: #C00;
      color: #FFF;
      font-size: 12px;
      height: 16px;
      width: 16px;
      text-align: center;
      border-radius: 50%;
      right: 0;
      bottom: 0;
      transform: translate(50%, 50%);
      display: flex;
      align-content: center;
      justify-content: center;
      flex-wrap: wrap;
    }
`
];

});
parcelRegister("aXDrb", function(module, exports) {

$parcel$export(module.exports, "fontAwesomeStyles", () => $7fae018cdcebb570$export$8bae91c7e534d3bf);
const $7fae018cdcebb570$var$faLink = document.createElement('link');
$7fae018cdcebb570$var$faLink.id = 'fontawesome';
$7fae018cdcebb570$var$faLink.rel = 'stylesheet';
$7fae018cdcebb570$var$faLink.href = 'images/fontawesome/css/all.css';
$7fae018cdcebb570$var$faLink.crossOrigin = 'anonymous';
document.head.appendChild($7fae018cdcebb570$var$faLink);
const $7fae018cdcebb570$export$8bae91c7e534d3bf = new CSSStyleSheet();
$7fae018cdcebb570$var$faLink.onload = ()=>{
    const fa = Array.from(document.styleSheets).find((s)=>s.ownerNode.matches('link#fontawesome'));
    Array.from(fa.cssRules).forEach((cssRule)=>{
        $7fae018cdcebb570$export$8bae91c7e534d3bf.insertRule(cssRule.cssText);
    });
};

});



parcelRegister("3S5XD", function(module, exports) {

$parcel$export(module.exports, "ALL", () => $2d1b09f6e41d6f41$export$61b49a5ae59d663);
$parcel$export(module.exports, "randomString", () => $2d1b09f6e41d6f41$export$7fa8378418b4411e);
const $2d1b09f6e41d6f41$export$f50e85c1c0d0eabf = 'abcdefghijklmnopqrstuvwxyz';
const $2d1b09f6e41d6f41$export$ffd06b780791fb0d = $2d1b09f6e41d6f41$export$f50e85c1c0d0eabf.toUpperCase();
const $2d1b09f6e41d6f41$export$4d318981b5a83836 = '0123456789';
const $2d1b09f6e41d6f41$export$688bd2194e110bb4 = `!@#$%^&*()_+-=|\\{}[]<>,.?/:";'~`;
const $2d1b09f6e41d6f41$export$376a9ed239d6c1c8 = `${$2d1b09f6e41d6f41$export$f50e85c1c0d0eabf}${$2d1b09f6e41d6f41$export$ffd06b780791fb0d}${$2d1b09f6e41d6f41$export$4d318981b5a83836}`;
const $2d1b09f6e41d6f41$export$61b49a5ae59d663 = `${$2d1b09f6e41d6f41$export$376a9ed239d6c1c8}${$2d1b09f6e41d6f41$export$688bd2194e110bb4}`;
const $2d1b09f6e41d6f41$export$7fa8378418b4411e = (length, alphabet = $2d1b09f6e41d6f41$export$376a9ed239d6c1c8)=>new Array(length).fill(1).map(()=>alphabet[Math.floor(Math.random() * alphabet.length)]).join('');

});

parcelRegister("4gjhp", function(module, exports) {

$parcel$export(module.exports, "ADD_TOAST", () => $31a79c9689763b20$export$be6101a96815ead4);
$parcel$export(module.exports, "UPDATE_TOAST", () => $31a79c9689763b20$export$45ff11e0aa582749);
$parcel$export(module.exports, "CLEAR_TOAST", () => $31a79c9689763b20$export$9a9d6a0c0c844b20);
const $31a79c9689763b20$export$be6101a96815ead4 = 'ADD_TOAST';
const $31a79c9689763b20$export$45ff11e0aa582749 = 'UPDATE_TOAST';
const $31a79c9689763b20$export$9a9d6a0c0c844b20 = 'CLEAR_TOAST';

});


parcelRegister("3CBzT", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $2a3211e11d8d5849$export$9a00dee1beb8f576);
/**
 * Capitalizes the first letter of each word, delimited by spaces or hyphens.
 * @param {string} str
 * @return {string}
 */ const $2a3211e11d8d5849$export$9a00dee1beb8f576 = (str)=>str.split(/([-\s]+)/).map((wordOrDelimiter, index)=>index % 2 === 1 ? wordOrDelimiter : `${wordOrDelimiter[0].toUpperCase()}${wordOrDelimiter.slice(1)}`).join('');

});


parcelRegister("buHtb", function(module, exports) {

$parcel$export(module.exports, "pushNotifications", () => $85e437341c9b7b5e$export$850c796c56728355);

var $8FBvR = parcelRequire("8FBvR");

var $kYBQo = parcelRequire("kYBQo");
function $85e437341c9b7b5e$var$_defineProperty(e, r, t) {
    return (r = $85e437341c9b7b5e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $85e437341c9b7b5e$var$_toPropertyKey(t) {
    var i = $85e437341c9b7b5e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $85e437341c9b7b5e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $85e437341c9b7b5e$export$8f83d3f28eb09744 {
    constructor(){
        /**
     * The chartCheckId we are connected as.
     * @type {string|undefined}
     */ $85e437341c9b7b5e$var$_defineProperty(this, "_connectedAs", undefined);
        /**
     * Listeners for specific notification types.
     * @type {Array.<{ type:string, callback:PushNotificationCallback }>}
     */ $85e437341c9b7b5e$var$_defineProperty(this, "_listeners", []);
        /**
     * Subscriptions which receive all notifications.
     * @type {PushNotificationCallback[]}
     */ $85e437341c9b7b5e$var$_defineProperty(this, "_subscriptions", []);
        /**
     * The actual connection
     * @type {EventSource|undefined}
     */ $85e437341c9b7b5e$var$_defineProperty(this, "_eventSource", void 0);
        /**
     * @type {function()|undefined}
     */ $85e437341c9b7b5e$var$_defineProperty(this, "_unsubscribeStore", undefined);
        $85e437341c9b7b5e$var$_defineProperty(this, "_handleStateChange", (state)=>{
            const me = (0, $8FBvR.meSelector)(state);
            if (this._eventSource && me?.chartCheckId !== this._connectedAs) {
                this.disconnect();
                this.connect();
            }
        });
        $85e437341c9b7b5e$var$_defineProperty(this, "_handleMessage", (event)=>{
            const data = JSON.parse(event.data);
            const { type: type } = data;
            const callbacks = [
                ...this._listeners.filter((s)=>s.type === type).map(({ callback: callback })=>callback),
                ...this._subscriptions
            ];
            for (let callback of callbacks)callback(data);
        });
    }
    isConnected() {
        return this._eventSource?.readyState === EventSource.OPEN;
    }
    /**
   * Connects to the server.
   * Automatically reconnect or disconnects if the user's credentials change (they log in/out)
   */ connect() {
        const me = (0, $8FBvR.meSelector)((0, $kYBQo.getStore)().getState());
        this._eventSource = new EventSource('/weekly-check/api/push');
        this._eventSource.addEventListener('message', this._handleMessage);
        this._unsubscribeStore = (0, $kYBQo.getStore)().subscribe(this._handleStateChange);
        this._connectedAs = me?.chartCheckId;
    }
    /**
   * Disconnects from the server.
   */ disconnect() {
        this._eventSource?.close();
        this._eventSource = undefined;
        this._unsubscribeStore?.();
        this._connectedAs = undefined;
    }
    /**
   * Listens for a specific notification type.
   * @param {string} type
   * @param {PushNotificationCallback} callback
   */ addListener(type, callback) {
        this._listeners.push({
            type: type,
            callback: callback
        });
    }
    /**
   * Removes a listener.
   * @param {string} type
   * @param {PushNotificationCallback} callback
   */ removeListener(type, callback) {
        const index = this._listeners.findIndex((subscription)=>subscription.type === type && subscription.callback === callback);
        if (index === -1) return;
        this._listeners.splice(index, 1);
    }
    /**
   * Subscribes to all messages.
   * @param {PushNotificationCallback} callback
   */ subscribe(callback) {
        this._subscriptions.push(callback);
    }
    /**
   * Removes a specific subscribe() callback.
   * @param {PushNotificationCallback} callback
   */ unsubcribe(callback) {
        const index = this._subscriptions.indexOf(callback);
        if (index === -1) return;
        this._subscriptions.splice(index, 1);
    }
}
const $85e437341c9b7b5e$export$850c796c56728355 = new $85e437341c9b7b5e$export$8f83d3f28eb09744();

});

parcelRegister("fay89", function(module, exports) {

$parcel$export(module.exports, "routerManager", () => $b0b243cb5e76464c$export$490cee87946384cb);
// Do not import directly. Use with getRouter() and setRouter() only.
const $b0b243cb5e76464c$export$490cee87946384cb = {
    router: undefined
};

});

parcelRegister("2YpSS", function(module, exports) {
module.exports = Promise.all([
    import("cDAc7"),
    import("g490P")
]).then(()=>parcelRequire('5SHaA'));

});


var $8FBvR = parcelRequire("8FBvR");
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;



var $fp8Uu = parcelRequire("fp8Uu");
const $ab0bbef82a3d9b93$var$INITIAL_STATE = {};
const $ab0bbef82a3d9b93$var$showOverlay = (state, { show: show })=>({
        ...state,
        showOverlay: show
    });
const $ab0bbef82a3d9b93$var$updatePage = (state, { page: page, params: params, query: query, requiresAuth: requiresAuth })=>({
        ...state,
        page: page,
        params: params,
        query: query,
        authReady: !requiresAuth,
        authGranted: requiresAuth ? undefined : true
    });
// If page doesn't match the current page, it means they've navigated to a new page before we authed,
//  so throw away this auth.
const $ab0bbef82a3d9b93$var$authorizedPage = (state, { page: page, granted: granted })=>page === state.page ? {
        ...state,
        authReady: true,
        authGranted: Boolean(granted)
    } : state;
const $ab0bbef82a3d9b93$var$updateConfig = (state, { config: config })=>({
        ...state,
        config: config
    });
const $ab0bbef82a3d9b93$var$updateSettings = (state, { settings: settings })=>({
        ...state,
        settings: settings,
        settingsLoaded: true
    });
const $ab0bbef82a3d9b93$var$updateImageQueuePatientStatus = (state, { imageQueuePatientStatus: imageQueuePatientStatus })=>({
        ...state,
        imageQueuePatientStatus: imageQueuePatientStatus
    });
const $ab0bbef82a3d9b93$var$updateMe = (state, { me: me })=>({
        ...state,
        me: me
    });
const $ab0bbef82a3d9b93$var$updatePatient = (state, { patient: patient })=>({
        ...state,
        patient: patient
    });
const $ab0bbef82a3d9b93$var$updateSystemSettings = (state, { systemSettings: systemSettings })=>({
        ...state,
        systemSettings: systemSettings
    });
const $ab0bbef82a3d9b93$var$verifyDisabled = (state, { disabled: disabled })=>({
        ...state,
        verifyDisabled: disabled
    });
const $ab0bbef82a3d9b93$var$reducers = {
    [(0, $fp8Uu.UPDATE_PAGE)]: $ab0bbef82a3d9b93$var$updatePage,
    [(0, $fp8Uu.AUTHORIZE_PAGE)]: $ab0bbef82a3d9b93$var$authorizedPage,
    [(0, $fp8Uu.UPDATE_CONFIG)]: $ab0bbef82a3d9b93$var$updateConfig,
    [(0, $fp8Uu.UPDATE_SETTINGS)]: $ab0bbef82a3d9b93$var$updateSettings,
    [(0, $fp8Uu.UPDATE_ME)]: $ab0bbef82a3d9b93$var$updateMe,
    [(0, $fp8Uu.UPDATE_PATIENT)]: $ab0bbef82a3d9b93$var$updatePatient,
    [(0, $fp8Uu.SHOW_OVERLAY)]: $ab0bbef82a3d9b93$var$showOverlay,
    [(0, $fp8Uu.VERIFY_DISABLED)]: $ab0bbef82a3d9b93$var$verifyDisabled,
    [(0, $fp8Uu.UPDATE_SYSTEM_SETTINGS)]: $ab0bbef82a3d9b93$var$updateSystemSettings,
    [(0, $fp8Uu.UPDATE_IMAGE_QUEUE_PATIENT_STATUS)]: $ab0bbef82a3d9b93$var$updateImageQueuePatientStatus
};
const $ab0bbef82a3d9b93$export$729c8b7179294ba = (state = $ab0bbef82a3d9b93$var$INITIAL_STATE, action)=>($ab0bbef82a3d9b93$var$reducers[action.type] || ((state)=>state))(state, action);



var $4gjhp = parcelRequire("4gjhp");

var $ivRuz = parcelRequire("ivRuz");

var $dgn0U = parcelRequire("dgn0U");

var $jIFAb = parcelRequire("jIFAb");
const $e5d2b7166913f0fd$var$INITIAL_STATE = {};
const $e5d2b7166913f0fd$var$addToast = (state, { message: message, color: color, id: id, state: toastState })=>({
        ...state,
        toasts: (0, $jIFAb.replaceValueMatching)(state.toasts || [], (toast)=>toast.id === id, {
            message: message,
            color: color,
            id: id,
            state: toastState
        })
    });
const $e5d2b7166913f0fd$var$updateToast = (state, { id: id, state: toastState })=>{
    const toast = state.toasts?.find((toast)=>toast.id === id);
    return {
        ...state,
        toasts: toast ? (0, $dgn0U.replaceValue)(state.toasts, toast, {
            ...toast,
            state: toastState
        }) : []
    };
};
const $e5d2b7166913f0fd$var$clearToast = (state, { id: id })=>({
        ...state,
        toasts: (0, $ivRuz.removeValueMatching)(state.toasts || [], (toast)=>toast.id === id)
    });
const $e5d2b7166913f0fd$var$reducers = {
    [(0, $4gjhp.ADD_TOAST)]: $e5d2b7166913f0fd$var$addToast,
    [(0, $4gjhp.CLEAR_TOAST)]: $e5d2b7166913f0fd$var$clearToast,
    [(0, $4gjhp.UPDATE_TOAST)]: $e5d2b7166913f0fd$var$updateToast
};
const $e5d2b7166913f0fd$export$5a6435f4c4f68512 = (state = $e5d2b7166913f0fd$var$INITIAL_STATE, action)=>($e5d2b7166913f0fd$var$reducers[action.type] || ((state)=>state))(state, action);


// Sets up a Chrome extension for time travel debugging.
// See https://github.com/zalmoxisus/redux-devtools-extension for more information.
const $ae05e02bf59e754c$var$devCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
const $ae05e02bf59e754c$export$6f57813fe9f31bf9 = (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)((0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    app: $ab0bbef82a3d9b93$export$729c8b7179294ba,
    toasts: $e5d2b7166913f0fd$export$5a6435f4c4f68512
}), $ae05e02bf59e754c$var$devCompose((0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)((0, $44400fc0fe63e7bd$export$dd164f5517779f15))));



var $04gBu = parcelRequire("04gBu");

var $1XhrH = parcelRequire("1XhrH");

var $kYBQo = parcelRequire("kYBQo");

var $kL15l = parcelRequire("kL15l");

var $jI9i2 = parcelRequire("jI9i2");
const $4909143eaa758525$export$aafd712b16ccb3b1 = (me, organizationSlug)=>{
    var _me$organizations$fin;
    return (0, $jI9i2.distinct)((organizationSlug ? (_me$organizations$fin = me.organizations.find(({ slug: slug })=>slug === organizationSlug)?.products) !== null && _me$organizations$fin !== void 0 ? _me$organizations$fin : [] : me.organizations.flatMap(({ products: products })=>products)).flatMap(({ roles: roles })=>roles.flatMap(({ permissions: permissions })=>permissions.flatMap(({ id: id })=>id))));
};



var $iGpZk = parcelRequire("iGpZk");

var $iXmyP = parcelRequire("iXmyP");

var $6i2Q5 = parcelRequire("6i2Q5");

var $11FeY = parcelRequire("11FeY");

var $4hATe = parcelRequire("4hATe");

var $kYBQo = parcelRequire("kYBQo");
function $de599a1ba622319b$var$_classPrivateMethodInitSpec(e, a) {
    $de599a1ba622319b$var$_checkPrivateRedeclaration(e, a), a.add(e);
}
function $de599a1ba622319b$var$_classPrivateFieldInitSpec(e, t, a) {
    $de599a1ba622319b$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $de599a1ba622319b$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $de599a1ba622319b$var$_classPrivateFieldSet(s, a, r) {
    return s.set($de599a1ba622319b$var$_assertClassBrand(s, a), r), r;
}
function $de599a1ba622319b$var$_classPrivateFieldGet(s, a) {
    return s.get($de599a1ba622319b$var$_assertClassBrand(s, a));
}
function $de599a1ba622319b$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
var $de599a1ba622319b$var$_me = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_paramGetters = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_beforeCallback = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_notFoundCallback = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_notFoundRoute = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_routes = /*#__PURE__*/ new WeakMap();
var $de599a1ba622319b$var$_Router_brand = /*#__PURE__*/ new WeakSet();
class $de599a1ba622319b$export$55185c17a0fcbe46 {
    constructor(){
        $de599a1ba622319b$var$_classPrivateMethodInitSpec(this, $de599a1ba622319b$var$_Router_brand);
        /**
     * @type {Promise<RadHttpResponse<UserInfo>>}
     * @desc A Promise that eventually resolves to /me or produces an error.
     */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_me, void 0);
        /** @type {Array.<Router~paramGetter>} */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_paramGetters, []);
        /** @type {Router~before} */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_beforeCallback, void 0);
        /** @type {Router~routeUses} */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_notFoundCallback, void 0);
        /** @type {Route} */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_notFoundRoute, void 0);
        /** @type {Route[]} */ $de599a1ba622319b$var$_classPrivateFieldInitSpec(this, $de599a1ba622319b$var$_routes, []);
        $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_loadMe).call(this);
        window.addEventListener('popstate', ()=>{
            this.resolve();
        });
    }
    /**
   * Navigates to the given path.
   * @param {string} path
   * @param {boolean} fullRedirect=false If true, it will do a full page change instead of a history push.
   */ navigate(path, fullRedirect = false) {
        if (!$de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_beforeCallback, this)) {
            $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_doNavigate).call(this, path, fullRedirect);
            return;
        }
        $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_beforeCallback, this).call(this, (resolve = true)=>{
            resolve && $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_doNavigate).call(this, path, fullRedirect);
        });
    }
    generate(routeName, params = {}, query = {}, hash = '') {
        var _route$route$match;
        const route = $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_routes, this).find(({ pageName: pageName })=>pageName === routeName);
        if (!route) return undefined;
        const paramsToReplace = (_route$route$match = route.route.match(/(?<=:)([^/]+)/g)) !== null && _route$route$match !== void 0 ? _route$route$match : [];
        const url = paramsToReplace.reduce((str, key)=>{
            var _params$key;
            return str.replace(new RegExp(`:${key}(/?)`, 'g'), `${(_params$key = params[key]) !== null && _params$key !== void 0 ? _params$key : $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_paramGetters, this).find((getter)=>getter(key))?.(key)}$1`);
        }, route.route);
        const queryParamsString = (0, $4hATe.queryToString)(query);
        return `${url}${queryParamsString}${hash ? `#${hash}` : ''}`;
    }
    /**
   * Resolves the given (or current) path
   * @param {string} path
   * @returns {{ route:{ pageName:string, path:string, resolved:string }, params:Object.<string, string> }}
   */ resolve(path = (0, $iGpZk.locationProvider).pathname) {
        const route = $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_routes, this).find(({ pattern: pattern })=>pattern.test(path));
        if (!route) {
            $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_notFoundCallback, this)?.call(this);
            return {
                route: {
                    pageName: $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_notFoundRoute, this)?.pageName,
                    path: undefined
                },
                params: {},
                resolved: path
            };
        }
        const { pattern: pattern, pageName: pageName, uses: uses, permissions: permissions } = route;
        const { groups: params } = path.match(pattern);
        const query = (0, $iXmyP.getQueryParams)();
        const requiresAuth = Boolean(permissions?.length);
        uses(params, query, requiresAuth);
        if (requiresAuth) // noinspection JSIgnoredPromiseFromCall
        $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_authorize).call(this, pageName, permissions, params?.organization);
        return {
            route: {
                pageName: route.pageName,
                path: route.route
            },
            params: params,
            resolved: path
        };
    }
    /**
   * Updates the query and/or hash of the current route.
   * @param {{ query: {}?, hash: {}? }} options The options to update.
   * @param {Boolean} dispatchNavigate If true, it'll dispatch the navigate event.
   */ update({ query: query, hash: hash }, dispatchNavigate = true) {
        let newPath = (0, $iGpZk.locationProvider).pathname;
        if (query !== undefined) {
            const queryParams = (0, $iXmyP.getQueryParams)((0, $iGpZk.locationProvider).search);
            Object.assign(queryParams, query);
            newPath += (0, $6i2Q5.toQueryString)(queryParams);
        } else newPath += (0, $iGpZk.locationProvider).search;
        if (hash !== undefined) newPath += !hash || hash.startsWith('#') ? hash : `#${hash}`;
        else newPath += (0, $iGpZk.locationProvider).hash;
        history.pushState('', '', newPath);
        if (dispatchNavigate) document.dispatchEvent(new CustomEvent('navigate'));
    }
    /**
   * Registers routes to the router.
   * @param {Object.<string, RouteConfig>} routeConfig An object of route configs. The key is their route name.
   * @returns {Router}
   */ on(routeConfig) {
        var _Object$entries$find;
        $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_routes, this, $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_buildRoutes).call(this, routeConfig));
        const [notFoundPageName, notFoundRoute] = (_Object$entries$find = Object.entries(routeConfig).find(([_, { notFound: notFound }])=>notFound)) !== null && _Object$entries$find !== void 0 ? _Object$entries$find : [];
        if (notFoundRoute) this.notFound(notFoundRoute, notFoundPageName);
        return this;
    }
    notFound(notFoundRoute, pageName = 'not-found') {
        $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_notFoundRoute, this, notFoundRoute);
        $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_notFoundCallback, this, $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_changePageUses).call(this, pageName, notFoundRoute.view));
        return this;
    }
    hooks({ before: before }) {
        $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_beforeCallback, this, before);
        return this;
    }
    params(...paramGetters) {
        $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_paramGetters, this, paramGetters);
        return this;
    }
}
/**
 * @callback Router~routeUses
 * @param {{}} [params=]
 * @param {string} [query=]
 * @param {boolean} [requiredAuth=]
 */ /**
 * @callback Router~paramGetter
 * @param {string} paramName
 * @return {string|undefined} The value for the parameter, or undefined if it isn't handled or empty.
 */ /**
 * @callback Router~before
 * @param {boolean} resolve
 */ /**
 * @typedef RouteConfig
 * @property {string} route The path for the route
 * @property {string[]} permissions Permissions required for the route
 * @property {function():Promise} view Loads the view
 * @property {string} title The subtitle to add when on this page
 * @property {function():Promise.<lit.TemplateResult>} render Renders the route
 * @property {string} forward Indicates another route to forward to
 * @property {boolean} notFound Indicates if this is the route for not found
 */ /**
 * @typedef Route
 * @property {string} pageName The name of the route
 * @property {string} route The route of the route
 * @property {RegExp} pattern The pattern to use when matching the route
 * @property {Router~routeUses} uses The method called when this route is resolved
 * @property {string[]} permissions The permissions needed for this route
 */ function $de599a1ba622319b$var$_loadMe() {
    $de599a1ba622319b$var$_classPrivateFieldSet($de599a1ba622319b$var$_me, this, (0, $11FeY.radHttp).get('./auth/api/me'));
    return this;
}
function $de599a1ba622319b$var$_doNavigate(path, fullRedirect = true) {
    if (fullRedirect) {
        (0, $iGpZk.locationProvider).href = path;
        return;
    }
    history.pushState('', '', path);
    this.resolve(`/${path}`.replace(/^\/+/, '/'));
    document.dispatchEvent(new CustomEvent('navigate'));
}
async function $de599a1ba622319b$var$_authorize(pageName, permissions, organization) {
    const { ok: ok, data: data } = await $de599a1ba622319b$var$_classPrivateFieldGet($de599a1ba622319b$var$_me, this);
    if (!ok) {
        (0, $kYBQo.getStore)().dispatch((0, $kL15l.authorize)(pageName, false));
        return;
    }
    const userPermissions = (0, $4909143eaa758525$export$aafd712b16ccb3b1)(data, organization);
    (0, $kYBQo.getStore)().dispatch((0, $kL15l.authorize)(pageName, permissions.every((p)=>userPermissions.includes(p))));
}
/**
 * Converts RouteConfig objects into intermediate Route objects
 * @param {Object.<string, RouteConfig>} routeConfigs
 * @returns {Route[]}
 */ function $de599a1ba622319b$var$_buildRoutes(routeConfigs) {
    return Object.entries(routeConfigs).filter(([, { notFound: notFound }])=>!notFound).map(([pageName, { view: view, route: route, forward: forward, permissions: permissions, notFound: notFound }])=>{
        return {
            pageName: pageName,
            route: route,
            permissions: permissions,
            notFound: notFound,
            uses: forward ? $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_forwardPageUses).call(this, pageName, forward) : $de599a1ba622319b$var$_assertClassBrand($de599a1ba622319b$var$_Router_brand, this, $de599a1ba622319b$var$_changePageUses).call(this, pageName, view),
            pattern: new RegExp(`^${route.replace(/:([^/]+)!/g, '(?<$1>.+)').replace(/:([^/]+)/g, '(?<$1>[^/]+)').replace(/\//g, '\\/')}\\/?$`)
        };
    });
}
/** @return {Router~routeUses} */ function $de599a1ba622319b$var$_changePageUses(pageName, loadFile = ()=>{}) {
    return (params = {}, query = '', requiresAuth = false)=>{
        (0, $kYBQo.getStore)().dispatch((0, $kL15l.navigate)(pageName, loadFile, params, query, requiresAuth));
    };
}
/** @return {Router~routeUses} */ function $de599a1ba622319b$var$_forwardPageUses(_, forward) {
    return (params = {}, query = '')=>{
        this.navigate(`${this.generate(forward, params)}${(0, $4hATe.queryToString)(query)}`);
    };
}


const $a66379539387d717$export$5375cda95f0b0eb4 = new (0, $de599a1ba622319b$export$55185c17a0fcbe46)((0, $kYBQo.getStore));
const $a66379539387d717$var$hooks = {
    before: (doneCallback)=>{
        const done = (goToNext = true)=>{
            doneCallback(goToNext);
        };
        const event = new CustomEvent('beforenav', {
            cancelable: true,
            detail: {
                done: done
            }
        });
        if (window.dispatchEvent(event)) done();
    }
};
$a66379539387d717$export$5375cda95f0b0eb4.params((0, $1XhrH.getDefaultParam)).hooks($a66379539387d717$var$hooks).on((0, $04gBu.routes));



var $g8NJW = parcelRequire("g8NJW");

var $1XhrH = parcelRequire("1XhrH");

var $buHtb = parcelRequire("buHtb");

var $11FeY = parcelRequire("11FeY");

var $6OKUw = parcelRequire("6OKUw");
const $87fed39d27f8417f$export$fa23577ed00dcf0e = (store)=>{
    (0, $6OKUw.storeManager).store = store;
};




var $fay89 = parcelRequire("fay89");
const $cd3b770c4fb6e183$export$6142de96feec4847 = (router)=>{
    (0, $fay89.routerManager).router = router;
};


(0, $87fed39d27f8417f$export$fa23577ed00dcf0e)((0, $ae05e02bf59e754c$export$6f57813fe9f31bf9));
(0, $cd3b770c4fb6e183$export$6142de96feec4847)((0, $a66379539387d717$export$5375cda95f0b0eb4));
(0, $a66379539387d717$export$5375cda95f0b0eb4).resolve();
(0, $11FeY.radHttp).getDefaultParam = (0, $1XhrH.getDefaultParam);
(0, $11FeY.radHttp).defaultResponseHandler = ({ response: response })=>{
    if (response?.status !== 401) return;
    window.location.href = `${(0, $8FBvR.configSelector)().loginUrl}?ReturnUrl=${encodeURIComponent(window.location.href)}`;
};
(0, $buHtb.pushNotifications).connect();
(0, $g8NJW.downloads).enable();

// Must be this style import or else getDefaultParam won't be set in time.
(parcelRequire("2YpSS"));


//# sourceMappingURL=client.47e079a4.js.map
